import Moment from 'moment/moment'

// utils
import bigInt from 'big-integer'
import {compareIsAfter, formatDate} from '../../../utils/date'
import { stck } from '~/utils/common' // TAMS

// TAMS
import { i18n } from '~/plugins/i18n'
// import { Validator } from 'vee-validate'

/**
 * Vee-Validate
 * Custom Rule Set
 *
 * @since: 2018-03-24
 * @author: kdydesign.kim
 *
 */

export const testRule = (Validator) => {
  Validator.extend('testRule', {
    getMessage: field => `The ${field} is not a valid coupon.!!!!!!!!!!!!!!!!!!!!!`,
    validate: value => {
      return value === 'test'
    }
  })
}

/**
 * isValidId
 * ID 문자열 유효성 검사를 수행한다. 4자 ~ 20자 이상의 알파벳과 숫자 검증.
 */
export const isValidId = (Validator) => {
  Validator.extend('isValidId', {
    getMessage: () => i18n.t('vl.isValidId'),
    validate: (id) => {
      const idRegex = /^[A-Za-z0-9]{4,20}$/
      if (!idRegex.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidOtpKey
 * Otp Key 문자열 유효성 검사를 수행한다. 4자의 알파벳과 숫자 검증.
 */
export const isValidOtpKey = (Validator) => {
  Validator.extend('isValidOtpKey', {
    getMessage: () => i18n.t('vl.isValidOtpKey'),
    validate: (id) => {
      const idRegex = /^[A-Fa-f0-9]{4}$/ // TAMS
      if (!idRegex.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidLoginId
 * 첫글자는 영문으로 시작하고, 영문/숫자만 가능함. 4~32자리, 3개의 특수문자 허용 (.-_)
 */
export const isValidLoginId = (Validator) => {
  Validator.extend('isValidLoginId', {
    getMessage: () => i18n.t('vl.isValidLoginId'),
    validate: (id) => {
      const idReg = /^[a-zA-Z]+[a-zA-Z0-9|\-|.|_]{3,31}$/g
      if (!idReg.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidLoginIdA1
 * 첫글자는 영문으로 시작하고, 영문/숫자만 가능함. 4~32자리, 3개의 특수문자 허용 (.-_)
 * 반드시 영문/숫자를 혼용해야 함.
 */
export const isValidLoginIdA1 = (Validator) => {
  Validator.extend('isValidLoginIdA1', {
    getMessage: () => i18n.t('vl.isValidLoginIdA1'),
    validate: (id) => {
      const idReg = /^[a-zA-Z]+[a-zA-Z0-9|\-|.|_]{3,31}$/g
      if (!idReg.test(id)) {
        return false
      }
      const regExpNum = /[0-9]/
      if (!regExpNum.test(id)) {
        return false
      }
      return true
    }
  })
}

const reservedWord = ['admin', 'administrator', 'test', 'qwe', 'user']
/* Well-Known Word('admin', 'administrator', 'test', 'qwe', 'user') 사용 불가 체크 */
export const isValidWellKnownWord = (Validator) => {
  Validator.extend('isValidWellKnownWord', {
    getMessage: () => i18n.t('vl.isValidWellKnownWord'),
    validate: (inputStr) => {
      // 지정된 문자 사용 불가
      for (const word of reservedWord) {
        if (inputStr.indexOf(word) >= 0) {
          return false
        }
      }
      return true
    }
  })
}

const reservedCommunityWord = ['private', 'public', 'admin']
/* Well-Known Word('private', 'public', 'admin') 사용 불가 체크 */
export const isValidWellKnownWordCommunity = (Validator) => {
  Validator.extend('isValidWellKnownWordCommunity', {
    getMessage: () => i18n.t('vl.isValidWellKnownWordCommunity'),
    validate: (inputStr) => {
      // 지정된 문자 사용 불가
      for (const word of reservedCommunityWord) {
        if (inputStr.indexOf(word) >= 0) {
          return false
        }
      }
      return true
    }
  })
}

/**
 * isValidPasswd
 * 8자 ~ 20자, 특수문자, 알파벳 대소문자 허용으로 이루어진 비밀번호 검증.
 */
export const isValidPasswd = (Validator) => {
  Validator.extend('isValidPasswd', {
    getMessage: () => i18n.t('vl.isValidPasswd'),
    validate: (password) => {
      const pwRegex = /^.*(?=^.{8,20}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/
      if (!pwRegex.test(password)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidPasswdRepeat
 * 입력된 비밀번호가 동일한지 확인.
 */
export const isValidPasswdRepeat = (Validator) => {
  Validator.extend('isValidPasswdRepeat', {
    getMessage: () => i18n.t('vl.isValidPasswdRepeat'),
    validate: (pwrpt, [originPw]) => {
      if (pwrpt !== originPw) {
        return false
      }

      return true
    }
  })
}

/**
 * isValidPasswd
 * 8자 ~ 32자, 특수문자, 알파벳 대소문자 허용으로 이루어진 비밀번호 검증.
 */
export const isValidPasswdMax32 = (Validator) => {
  Validator.extend('isValidPasswdMax32', {
    getMessage: () => i18n.t('vl.isValidPasswdMax32'),
    validate: (password) => {
      const pwRegex = /^.*(?=^.{8,32}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/
      if (!pwRegex.test(password)) {
        return false
      }
      return true
    }
  })
}

export const isValidPasswdRepeatAllWord = (Validator) => {
  Validator.extend('isValidPasswdRepeatAllWord', {
    getMessage: () => i18n.t('vl.isValidPasswdRepeat'),
    validate: (pwrpt, [originPw]) => {
      const pwd = pwrpt.replace(/,/gi, 'COMMA').replace(/\|/gi, 'PIPE')
      if (pwd !== originPw) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidIPv4
 * IPv4 주소 유효성 검사 수행.
 */
export const isValidIPv4 = (Validator) => {
  Validator.extend('isValidIPv4', {
    getMessage: () => i18n.t('vl.isValidIPv4'),
    validate: (ipList) => {
      if (ipList.length > 0) {
        ipList = ipList.replace(' ', '')
        // 쉼표로 구분된 IP 분리
        const ipv4List = ipList.split(',')
        const ipv4Regex = /^(([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])\.){3}([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])(\/(?:3[012]|[012]?[0-9])|)$/

        // 반복문으로 각 IP 체크
        for (let i = 0, max = ipv4List.length; i < max; i++) {
          // 유효성 검사를 통과하지 못하면 return false
          if (!ipv4Regex.test(ipv4List[i])) {
            return false
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidIPv4One
 * IPv4 주소 유효성 검사 수행. ( 단일 )
 */
export const isValidIPv4One = (Validator) => {
  Validator.extend('isValidIPv4One', {
    getMessage: () => i18n.t('vl.isValidIPv4One'),
    validate: (address) => {
      const ipv4Regex = /^(([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])\.){3}([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])(\/(?:3[012]|[012]?[0-9])|)$/
      return ipv4Regex.test(address)
    }
  })
}

/**
 * isValidIPv6
 * IPv6 주소 유효성 검사 수행.
 */
export const isValidIPv6 = (Validator) => {
  Validator.extend('isValidIPv6', {
    getMessage: () => i18n.t('vl.isValidIPv6'),
    validate: (address) => {
      const ipv6Regex = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i
      return ipv6Regex.test(address)
    }
  })
}

/**
 * isValidIPv4NetMask
 * IPv4 / Netmask 검증.
 */
export const isValidIPv4NetMask = (Validator) => {
  Validator.extend('isValidIPv4NetMask', {
    getMessage: () => i18n.t('vl.isValidIPv4NetMask'),
    validate: (ipList) => {
      if (ipList.length > 0) {
        ipList = ipList.replace(' ', '')
        // 쉼표로 구분된 IP 분리
        const ipv4List = ipList.split(',')
        const ipv4Regex = /^(([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])\.){3}([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])(\/(?:3[012]|[012]?[0-9])|)$/

        // 반복문으로 각 IP 체크
        for (let i = 0, max = ipv4List.length; i < max; i++) {
          // 유효성 검사를 통과하지 못하면 return false
          if (!ipv4Regex.test(ipv4List[i])) {
            return false
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidIPv4NetMaskOne
 * 단일 IPv4 / Netmask 검증.
 */
export const isValidIPv4NetMaskOne = (Validator) => {
  Validator.extend('isValidIPv4NetMaskOne', {
    getMessage: () => i18n.t('vl.isValidIPv4NetMaskOne'),
    validate: (ip) => {
      const ipv4Regex = /^(([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])\.){3}([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])(\/(?:3[012]|[012]?[0-9])|)$/

      // 유효성 검사를 통과하지 못하면 return false
      if (!ipv4Regex.test(ip)) {
        return false
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidIPv6NetMask
 * 단일 IPv6 / Mask 체크
 */
export const isValidIPv6NetMaskOne = (Validator) => {
  Validator.extend('isValidIPv6NetMaskOne', {
    getMessage: () => i18n.t('vl.isValidIPv6NetMaskOne'),
    validate: (value) => {
      const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/

      const ipArray = value.split('/')
      const ip = ipArray[0]
      if (!ipv6Regex.test(ip)) {
        return false
      }
      if (ipArray.length > 2) {
        return false
      }
      if (ipArray.length === 2) {
        const mask = ipArray[1]
        const regExpNum = /^[0-9]*$/
        if (!regExpNum.test(mask)) {
          return false
        }
        if (mask < 1 || mask > 128) {
          return false
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidPhone
 * [3자리]-[4자리]-[4자리]의 숫자로 이루어져야 합니다.
 */
export const isValidPhone = (Validator) => {
  Validator.extend('isValidPhone', {
    getMessage: () => i18n.t('vl.isValidPhone'),
    validate: (value) => {
      const PhoneRegex = /^\d{3}-\d{4}-\d{4}$/

      if (!PhoneRegex.test(value)) {
        return false
      }

      return true
    }
  })
}

/**
 * isValidPhone2
 * 휴대폰 번호 유효성검사
 */
export const isValidPhone2 = (Validator) => {
  Validator.extend('isValidPhone2', {
    getMessage: () => i18n.t('vl.isValidPhone2'),
    validate: (value) => {
      const PhoneRegex = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/

      if (!PhoneRegex.test(value)) {
        return false
      }

      return true
    }
  })
}

/**
 * isValidIPv6NetMask
 * ???
 */
export const isValidIPv6NetMask = (Validator) => {
  Validator.extend('isValidIPv6NetMask', {
    getMessage: () => i18n.t('vl.isValidIPv6NetMask'),
    validate: (ipList) => {
      const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/

      if (ipList.length > 0) {
        ipList = ipList.replace(' ', '')

        if (ipList.indexOf(':') < 0) {
          return false
        }

        let prefixIP = ipList.split('/')
        let arr = prefixIP[0].split(':')
        let firstValue = parseInt(arr[0], 16)

        if (!ipv6Regex.test(prefixIP[0]) && ipList !== '::') {
          return false
        } else {
          if (firstValue === 0x3ffe) {
            return false
          }

          if (ipList.substring(0, 2).toLowerCase() === 'ff') {
            if (arr[0].length === 4) {
              return false
            }
          }

          if (firstValue >= 0xfe80 && firstValue <= 0xfebf) {
            return false
          }
          if (firstValue >= 0xfec0 && firstValue <= 0xfeff) {
            return false
          }

          let tmpStr = ''
          let len = 0
          let tmpValue

          for (let i = 0; i < arr.length; i++) {
            tmpStr = arr[i].toString().toLowerCase()
            len = tmpStr.length

            for (let j = 0; j < len; j++) {
              tmpValue = tmpStr.charCodeAt(j)
              if ((tmpValue > 96 && tmpValue < 103) || (tmpValue > 47 && tmpValue < 58)) {
                continue
              } else {
                return false
              }
            }
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidIPv4IPv6
 * 쉼표로 구분된 여러 IP를 검증. IPv4, v6 가능.
 */
export const isValidIPv4IPv6 = (Validator) => {
  Validator.extend('isValidIPv4IPv6', {
    getMessage: () => i18n.t('vl.isValidIPv4IPv6'),
    validate: (ipList, param) => {
      if (ipList.length > 0) {
        ipList = ipList.replace(' ', '')
        // 쉼표로 구분된 IP 분리
        const ipAllList = ipList.split(',')
        const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]|[1-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]|[1-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]|[1-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]|[1-9][0-9]?)$/
        // IPv6 정규식 조금 다름 ( IPv4-Embedded IPv6 Address 막도록 변경 )
        const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4})$/

        // 반복문으로 각 IP 체크
        for (let i = 0, max = ipAllList.length; i < max; i++) {
          // 유효성 검사를 통과하지 못하면 return false
          if (ipAllList[i].indexOf('/') > -1 && ipAllList[i].indexOf('-') > -1) {
            return false
          }
          if (ipAllList[i].indexOf('/') > -1) {
            const ipTxt = ipAllList[i].split('/')
            const maxNetNum = (ipv4Regex.test(ipTxt[0])) ? 32 : 128

            if (!(ipv4Regex.test(ipTxt[0]) || ipv6Regex.test(ipTxt[0]))) {
              return false
            } else if (ipTxt.length === 2 && (ipTxt[1].length === 0 || Number(ipTxt[1]) > maxNetNum || Number(ipTxt[1]) < 0)) {
              return false
            }
          } else {
            const ipTxt = ipAllList[i].split('-')
            if (ipTxt.length > 2) {
              return false
            } else if (!(ipv4Regex.test(ipTxt[0]) || ipv6Regex.test(ipTxt[0]))) {
              return false
            } else if (ipTxt.length === 2 && !(ipv4Regex.test(ipTxt[1]) || ipv6Regex.test(ipTxt[1]))) {
              return false
            } else if (ipTxt.length === 2 &&
              !((ipv4Regex.test(ipTxt[0]) && ipv4Regex.test(ipTxt[1])) || (ipv6Regex.test(ipTxt[0]) && ipv6Regex.test(ipTxt[1])))) {
              return false
            } else if (ipTxt.length === 2) {
              const iIp1 = parseInt(ipTxt[0].replace(/\.|:/g, ''), 16)
              const iIp2 = parseInt(ipTxt[1].replace(/\.|:/g, ''), 16)

              if (isNaN(iIp1) || isNaN(iIp2) || iIp1 >= iIp2) {
                return false
              }
            }
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidMac
 * 쉼표로 구분된 여러 Mac 주소를 검증.
 */
export const isValidMac = (Validator) => {
  Validator.extend('isValidMac', {
    getMessage: () => i18n.t('vl.isValidMac'),
    validate: (macList) => {
      if (macList.length > 0) {
        macList = macList.replace(' ', '')
        // 쉼표로 구분된 IP 분리
        const arrMac = macList.split(',')
        const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/

        // 반복문으로 각 IP 체크
        for (let i = 0, max = arrMac.length; i < max; i++) {
          // 유효성 검사를 통과하지 못하면 return false
          if (arrMac[i].indexOf('/') > -1) {
            const ipTxt = arrMac[i].split('/')
            const maxNetNum = 128

            if (!macRegex.test(ipTxt[0])) {
              return false
            } else if (ipTxt.length === 2 && (ipTxt[1].length === 0 || Number(ipTxt[1]) > maxNetNum || Number(ipTxt[1]) < 0)) {
              return false
            }
          } else {
            let ipTxt = arrMac[i].split('-')
            if (ipTxt.length > 2) {
              return false
            } else if (!macRegex.test(ipTxt[0])) {
              return false
            } else if (ipTxt.length === 2 && !macRegex.test(ipTxt[1])) {
              return false
            } else if (ipTxt.length === 2) {
              const iIp1 = parseInt(ipTxt[0].replace(/:/g, ''), 16)
              const iIp2 = parseInt(ipTxt[1].replace(/:/g, ''), 16)

              if (isNaN(iIp1) || isNaN(iIp2) || iIp1 >= iIp2) {
                return false
              }
            }
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidMacComponent
 * MAC 컴포넌트에서 사용하는 유효성 검사 규칙.
 */
export const isValidMacComponent = (Validator) => {
  Validator.extend('isValidMacComponent', {
    getMessage: () => {
      return i18n.t('vl.isValidMacComponent')
    },
    validate: (mac) => {
      // MAC 주소 정규식
      const macRegex = /^([0-9A-Fa-f]{2})$/

      // 정규식 조회
      if (macRegex.test(mac)) {
        return true
      }

      return false
    }
  })
}

/**
 * isValidNetmask
 * IPv4 넷마스크 유효성 검증. 기본값은 0 ~ 32 입력가능.
 */
export const isValidNetmask = (Validator) => {
  Validator.extend('isValidNetmask', {
    getMessage: (prefix, [min, max]) => {
      return `${i18n.t('vl.isValidPrefix')} ${i18n.t('cmn.valueRange', {min, max})}`
    },
    validate: (prefix, [min, max]) => {
      const numPrefix = Number(prefix)

      if (numPrefix >= min && numPrefix <= max) {
        return true
      }

      return false
    }
  })
}

/**
 * isValidPrefix
 * IPv6 프리픽스 유효성 검증. 1 ~ 128 입력가능.
 */
export const isValidPrefix = (Validator) => {
  Validator.extend('isValidPrefix', {
    getMessage: (prefix, [min, max]) => {
      return `${i18n.t('vl.isValidPrefix')} ${i18n.t('cmn.valueRange', {min, max})}`
    },
    validate: (prefix, [min, max]) => {
      const numPrefix = Number(prefix)

      if (numPrefix >= min && numPrefix <= max) {
        return true
      }

      return false
    }
  })
}

/**
 * isValidPort
 * 쉼표로 구분된 여러개의 포트 검증.
 */
export const isValidPort = (Validator) => {
  Validator.extend('isValidPort', {
    getMessage: () => i18n.t('vl.isValidPort'),
    validate: (portList) => {
      if (portList.length > 0) {
        portList = portList.replace(' ', '')
        // 쉼표로 구분된 IP 분리
        const portArr = portList.split(',')
        const maxPort = 65535
        // 반복문으로 각 IP 체크
        for (let i = 0, max = portArr.length; i < max; i++) {
          // 유효성 검사를 통과하지 못하면 return false
          const strVal = portArr[i]
          if (strVal.indexOf('-') > -1) { // '-' 는 범위
            const strArr = strVal.split('-')
            if (strArr.length > 2 || strArr[0] === '' || strArr[1] === '') { // 잘못된 형식
              return false
            } else { // 범위 검사
              const num1 = Number(strArr[0])
              const num2 = Number(strArr[1])
              let numNan = isNaN(num1) || isNaN(num2)
              let numMax = num1 > maxPort || num2 > maxPort
              let numMin = num1 < 0 || num2 < 0
              if (numNan || numMax || numMin || num1 > num2) {
                return false
              }
            }
          } else {
            const num = Number(strVal)
            if (strVal === '' || isNaN(num) || num > maxPort || num < 0) {
              return false
            }
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidNumbers
 * 쉼표로 구분된 여러개의 숫자 검증.
 */
export const isValidNumbers = (Validator) => {
  Validator.extend('isValidNumbers', {
    getMessage: () => i18n.t('vl.isValidNumbers'),
    validate: (numberList) => {
      try {
        if (numberList.length > 0) {
          numberList = numberList.replace(' ', '')
          // 쉼표로 구분된 숫자 분리
          const numArr = numberList.split(',')
          const maxNum = bigInt('18446744073709551615')
          const minNum = bigInt('-9223372036854775808')
          // 반복문으로 각 숫자 체크
          for (let i = 0, max = numArr.length; i < max; i++) {
            // 유효성 검사를 통과하지 못하면 return false
            let strVal = numArr[i]
            let minusFlg = false
            const minusCnt = strVal.match(/-/g)
            // console.log('isValidNumbers[strVal, minusCnt, strVal.indexOf(-)]', strVal, minusCnt, strVal.indexOf('-'))
            if (minusCnt !== null && minusCnt !== undefined) {
              if (minusCnt.length > 3) {
                // - 가 3개 이상이면 -9999 - -1000 형식이 아니기 때문에 잘못된 입력
                // console.log('isValidNumbers: - 가 3개 이상이면 -9999 - -1000 형식이 아니기 때문에 잘못된 입력', minusCnt.length)
                return false
              }
              if (strVal.lastIndexOf('-') === (strVal.length - 1)) {
                // - 가 맨뒤에 있으면 잘못된 입력
                // console.log('isValidNumbers: - 가 맨뒤에 있으면 잘못된 입력', strVal.lastIndexOf('-'), (strVal.length - 1))
                return false
              }
              // - 가 3개인 경우는 -1000 - -100 만 정상이면서 범위입력이다
              if (minusCnt.length === 3) {
                if (strVal.indexOf('-') > 0) {
                  // - 가 3개지만 맨앞에 있지 않으므로 잘못된 입력
                  // console.log('isValidNumbers: - 가 3개지만 맨앞에 있지 않으므로 잘못된 입력', minusCnt.length, strVal.indexOf('-'))
                  return false
                }
                if (strVal.indexOf('---') > 0) {
                  // --- 가 입력되어 있으면 잘못된 입력
                  // console.log('isValidNumbers: --- 가 입력되어 있으면 잘못된 입력', minusCnt.length, strVal.indexOf('---'))
                  return false
                }
                minusFlg = true
              }
              // - 가 2개인 경우는 1000 - -100 또는 -1000 - 100 인경우만 정상이면서 범위입력이다.
              if (minusCnt.length === 2) {
                if (strVal.indexOf('--') === 0 || (strVal.indexOf('--') === (strVal.length - 1))) {
                  // -- 가 맨앞, 맨뒤에 있는 경우 잘못된 입력
                  // console.log('isValidNumbers: -- 가 맨앞, 맨뒤에 있는 경우 잘못된 입력', strVal.indexOf('--'))
                  return false
                }
                minusFlg = true
              }
              // - 가 1개 인경우는 -1000, 1000 - 100 인 경우만 정상입력
              if (minusCnt.length === 1) {
                if (strVal.indexOf('-') > 0) {
                  minusFlg = true
                } else {
                  minusFlg = false
                }
              }
            }

            if (minusFlg) { // 범위입력임
              // let arrTemp = []
              let strArr = []
              let pos = -1
              // 음수가 있는경우 범위와 겹치므로 다른 문자로 치환
              if (strVal.indexOf('--') > -1) {
                strVal = strVal.replace('--', '*-')
                strArr = strVal.split('*')
              } else {
                pos = strVal.indexOf('-', 1)
                strArr[0] = strVal.substring(0, pos)
                strArr[1] = strVal.substring(pos + 1, strVal.length)
              }

              if (strArr.length > 2 || strArr[0] === '' || strArr[1] === '') { // 잘못된 형식
                return false
              } else { // 범위 검사
                const num1 = bigInt(strArr[0])
                const num2 = bigInt(strArr[1])
                let numNan = isNaN(num1) || isNaN(num2)
                let numMax = num1.greater(maxNum) || num2.greater(maxNum)
                let numMin = num1.lesser(minNum) || num2.lesser(minNum)
                // console.log('범위입력[numNan, numMax, numMin, num1.greater(num2)]', numNan, numMax, numMin, num1.greater(num2))
                if (numNan || numMax || numMin || num1.greater(num2)) {
                  return false
                }
              }
            } else {
              const num = bigInt(strVal)
              // console.log('범위입력이 아님[num.greater(maxNum), num.lesser(minNum)]', num.greater(maxNum), num.lesser(minNum))
              if (strVal === '' || isNaN(num) || num.greater(maxNum) || num.lesser(minNum)) {
                return false
              }
            }
          }
        }
      } catch (e) {
        // console.log('isValidNumbers Exception', e)
        return false
      }
      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidServicePort
 * 서비스 포트 유효성 검사
 * 단일 : '*' 또는 0 ~65535, 0 ~ 255(ICMP인 경우)
 * 범위 : 단일값 - 단일값
 * 혼합 : 총 10개의 단일값, 범위값을 콤마로 구분
 */
export const isValidServicePort = (Validator) => {
  Validator.extend('isValidServicePort', {
    getMessage: () => i18n.t('vl.isValidServicePort'),
    validate: (value, [protocol]) => {
      const portRegex = /^(?:\*|(?:(?:\d{1,5}\-\d{1,5}|\d{1,5})(\,(?:\d{1,5}\-\d{1,5}|\d{1,5})){0,9}))$/
      if (!portRegex.test(value)) {
        return false
      }
      if (value === '*') {
        return true
      } else {
        const portStrArr = value.split(',')
        const maxPort = ([2, 16].indexOf(Number(protocol)) >= 0 ? 255 : 65535)
        for (let i = 0, max = portStrArr.length; i < max; i++) {
          if (portStrArr[i].indexOf('-') !== -1) {
            const portArr = portStrArr[i].split('-')
            const num1 = Number(portArr[0])
            const num2 = Number(portArr[1])
            if (num1 > maxPort || num1 < 0 || num2 > maxPort || num2 < 0 || num1 > num2) {
              return false
            }
          } else {
            const num = Number(portStrArr[i])
            if (num > maxPort || num < 0) {
              return false
            }
          }
        }
      }
      return true
    }
  })
}

/**
 * isValidAppSignaturePort
 * 애플리케이션 시그니쳐 포트 유효성 검사
 * 빈값과 ANY 예약어 유효
 * 단일 : '*' 또는 0 ~65535, 0 ~ 255(ICMP인 경우)
 * 범위 : 단일값 - 단일값
 * 혼합 : 총 10개의 단일값, 범위값을 콤마로 구분
 */
export const isValidAppSignaturePort = (Validator) => {
  Validator.extend('isValidAppSignaturePort', {
    getMessage: () => i18n.t('vl.isValidAppSignaturePort'),
    validate: (value, [protocol]) => {
      const portRegex = /^(?:\*|(?:(?:\d{1,5}\-\d{1,5}|\d{1,5})(\,(?:\d{1,5}\-\d{1,5}|\d{1,5})){0,9}))$/
      if (value === '') {
        return true
      }
      if (!portRegex.test(value)) {
        return false
      }
      if (value === '*') {
        return true
      } else {
        const portStrArr = value.split(',')
        const maxPort = (protocol === '2' ? 255 : 65535)
        for (let i = 0, max = portStrArr.length; i < max; i++) {
          if (portStrArr[i].indexOf('-') !== -1) {
            const portArr = portStrArr[i].split('-')
            const num1 = Number(portArr[0])
            const num2 = Number(portArr[1])
            if (num1 > maxPort || num1 < 0 || num2 > maxPort || num2 < 0 || num1 > num2) {
              return false
            }
          } else {
            const num = Number(portStrArr[i])
            if (num > maxPort || num < 0) {
              return false
            }
          }
        }
      }
      return true
    }
  })
}

/**
 * isMinimum
 * 최소값보다 작은지 검증
 */
export const isMinimum = (Validator) => {
  Validator.extend('isMinimum', {
    getMessage: () => i18n.t('vl.isMinimum'),
    validate: (value, [min]) => {
      if (Number(value) < min) {
        return false
      }
      return true
    }
  })
}

export const isMinimumRule = (Validator) => {
  Validator.extend('isMinimumRule', {
    getMessage: () => i18n.t('vl.isMinimumRule'),
    validate: (value, [min]) => {
      const regExp = /^[0-9]*$/
      // trim
      let chkVal = _.trim(value.toString())
      if (!regExp.test(chkVal)) {
        return false
      } else if (Number.isNaN(chkVal) || !Number.isInteger(Number(chkVal))) {
        return false
      } else if (Number(chkVal) < min) {
        return false
      } else {
        return true
      }
    }
  })
}

/**
 * isMaximum
 * 최대값보다 큰지 검증.
 */
export const isMaximum = (Validator) => {
  Validator.extend('isMaximum', {
    getMessage: () => i18n.t('vl.isMaximum'),
    validate: (value, [max]) => {
      if (Number(value) > max) {
        return false
      }
      return true
    }
  })
}

export const isMaximumRule = (Validator) => {
  Validator.extend('isMaximumRule', {
    getMessage: () => i18n.t('vl.isMaximumRule'),
    validate: (value, [max]) => {
      const regExp = /^[0-9]*$/
      // trim
      let chkVal = _.trim(value.toString())
      if (!regExp.test(chkVal)) {
        return false
      } else if (Number.isNaN(chkVal) || !Number.isInteger(Number(chkVal))) {
        return false
      } else if (Number(chkVal) > max) {
        return false
      } else {
        return true
      }
    }
  })
}

/**
 * 인증서 이름 규칙
 * 영문, 숫자, 특수문자 : ._- 3개만 허용
 * 시스템 > 인증서
 * 시스템 > HA 구성 > 장비 고유 ID
 */
export const isValidCertificateName = (Validator) => {
  Validator.extend('isValidCertificateName', {
    getMessage: () => i18n.t('vl.isValidCertificateName'),
    validate: text => {
      // 특수문자는  만 가능
      const regExp = /[^0-9a-zA-Z._\-]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

/**
 * 인증서 이름 규칙
 * 영문, 숫자, 특수문자 : _-.: 4개만 허용
 * 한글 불가
 */
export const isValidSslCertificateName = (Validator) => {
  Validator.extend('isValidSslCertificateName', {
    getMessage: () => i18n.t('vl.isValidSslCertificateName'),
    validate: text => {
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      // 특수문자는  만 가능
      const regExp = /[^0-9a-zA-Z_.:\-]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

/**
 * isValidCertificatePasswd
 * 인증서 암호 체크
 *  1. 한글 미포함
 * 2. 9자 이상 32자 이하
 * 3. space 포함 체크335
 * 4. 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
 * 5. 특수문자는 ~!@#%*()-+=_ 만 가능
 * 6. 미포함해야하는 특수문자 제외 ^[]{}|\[] 등 허용된 특수문자 외 제외
 * 7. 지정된 문자 사용 불가
 */
export const isValidCertificatePasswd = (Validator) => {
  Validator.extend('isValidCertificatePasswd', {
    getMessage: () => i18n.t('vl.isValidCertificatePasswd'),
    validate: pwd => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 9자 이상 32자 이하
      const len = pwd.length
      if (len < 9 || len > 32) {
        return false
      }

      // space 포함 체크
      if (pwd.indexOf(' ') >= 0) {
        return false
      }

      // 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
      // 특수문자는 ~!@#%*()-+_ 만 가능
      const regExp1 = /[a-z|A-Z]/
      const regExp2 = /[0-9]/
      const regExp3 = /[~|!|@|#|%|*|(|)|\-|+|=|_]/
      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd)) {
        return false
      }

      // 미포함해야하는 특수문자 제외 .;^[]{}|\[] 등 허용된 특수문자 외 제외
      const regExp4 = RegExp('[\\.|\\;|\\:|\\`|\\"|\\\'|\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\\]|\\{|\\}|\\|\\$|\\&]')
      if (regExp4.test(pwd)) {
        return false
      }

      // 지정된 문자 사용 불가
      for (const word of reservedWord) {
        if (pwd.indexOf(word) >= 0) {
          return false
        }
      }
      return true
    }
  })
}

/**
 * isValidAdminPasswd
 * 관리자 암호 체크
 * 1. 한글 포함 체크
 * 2. 9자 이상 32자 이하
 * 3. space 포함 체크
 * 4. 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
 * 5. 모든 특수문자 가능 ( 2018.07.24 이만영 책임 요구사항 : 모든 특수문자를 허용해야 함. )
 * 7. 지정된 문자 사용 불가
 * 8. ID와 3자리 이상 중복 불가
 * 9. ID 역순의 패스워드 검사
 * 10. (TAMS CC) 똑같은 문자나 숫자를 3자리 이상 연속
 * 11. (TAMS CC) 연속된 문자나 숫자를 3자리 이상 연속
 */
export const isValidAdminPasswd = (Validator) => {
  Validator.extend('isValidAdminPasswd', {
    getMessage: field => i18n.t('vl.isValidAdminPasswd'),
    validate: (pwd, [loginId]) => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎㅏ-ㅣ가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 9자 이상 32자 이하
      const len = pwd.length
      if (len < 9 || len > 32) {
        return false
      }

      // space 포함 체크
      if (pwd.indexOf(' ') >= 0) {
        return false
      }

      // 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
      // 모든 특수문자 가능
      const regExp1 = /[a-z|A-Z]/
      const regExp2 = /[0-9]/
      const regExp3 = /[~|!|@|#|$|%|&|*|(|)|_|+|\-|=|\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\]|\\{|\\}|\\`|\\.|\\:|\\;|\\"|\\'|\\|]/
      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd)) {
        return false
      }

      // 미포함해야하는 특수문자 제외 ^[]{}|\[] 등 허용된 특수문자 외 제외
      // const regExp4 = RegExp('[=|\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\\]|\\{|\\}|\\|\\`]')
      // if (regExp4.test(pwd)) {
      //   return false
      // }

      // 지정된 문자 사용 불가
      for (const word of reservedWord) {
        if (pwd.toLowerCase().indexOf(word) >= 0) {
          return false
        }
      }

      // ID와 3자리 이상 중복 불가
      for (let i = 0; i < loginId.length - 2; i++) {
        const word = loginId.substr(i, 3)
        if (pwd.indexOf(word) >= 0) {
          return false
        }
      }

      // ID 역순의 패스워드 검사
      const reverseId = loginId.split('').reverse().join('')
      if (pwd.indexOf(reverseId) >= 0) {
        return false
      }

      // TAMS
      // PW 똑같은/연속된 문자나 숫자를 3자리 이상 연속 체크
      const regexNo = /(\w)\1\1/
      if (!regexNo.test(pwd)) {
        if (!stck(pwd, 3)) {
          // 연속된 3자리 문자 사용 불가
          return false
        }
      } else {
        // 3개 이상 동일한 문자 사용 불가
        return false
      }

      return true
    }
  })
}

/**
 * isValidAdminPasswdCc
 * 관리자 암호 체크
 * 1. 한글 포함 체크
 * 2. 9자 이상 32자 이하
 * 3. space 포함 체크
 * 4. 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
 * 5. 모든 특수문자 가능 ( 2018.07.24 이만영 책임 요구사항 : 모든 특수문자를 허용해야 함. )
 * 7. 지정된 문자 사용 불가
 * 8. ID와 3자리 이상 중복 불가
 * 9. ID 역순의 패스워드 검사
 * 10. (TAMS CC) 똑같은 문자나 숫자를 3자리 이상 연속
 * 11. (TAMS CC) 연속된 문자나 숫자를 3자리 이상 연속
 */
export const isValidAdminPasswdCc = (Validator) => {
  Validator.extend('isValidAdminPasswdCc', {
    getMessage: field => i18n.t('vl.isValidAdminPasswd'),
    validate: (pwd, [loginId]) => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎㅏ-ㅣ가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 9자 이상 32자 이하
      const len = pwd.length
      if (len < 9 || len > 32) {
        return false
      }

      // space 포함 체크
      if (pwd.indexOf(' ') >= 0) {
        return false
      }

      // 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
      // 모든 특수문자 가능
      const regExp1 = /[a-z]/
      const regExp2 = /[A-Z]/
      const regExp3 = /[0-9]/
      const regExp4 = /[~|!|@|#|$|%|&|*|(|)|_|+|\-|=|\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\]|\\{|\\}|\\`|\\.|\\:|\\;|\\"|\\'|\\|]/
      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd) || !regExp4.test(pwd)) {
        return false
      }

      // 미포함해야하는 특수문자 제외 ^[]{}|\[] 등 허용된 특수문자 외 제외
      // const regExp4 = RegExp('[=|\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\\]|\\{|\\}|\\|\\`]')
      // if (regExp4.test(pwd)) {
      //   return false
      // }

      // 지정된 문자 사용 불가
      for (const word of reservedWord) {
        if (pwd.toLowerCase().indexOf(word) >= 0) {
          return false
        }
      }

      // ID와 3자리 이상 중복 불가
      for (let i = 0; i < loginId.length - 2; i++) {
        const word = loginId.substr(i, 3)
        if (pwd.indexOf(word) >= 0) {
          return false
        }
      }

      // ID 역순의 패스워드 검사
      const reverseId = loginId.split('').reverse().join('')
      if (pwd.indexOf(reverseId) >= 0) {
        return false
      }

      // TAMS
      // PW 똑같은/연속된 문자나 숫자를 3자리 이상 연속 체크
      const regexNo = /(\w)\1\1/
      if (!regexNo.test(pwd)) {
        if (!stck(pwd, 3)) {
          // 연속된 3자리 문자 사용 불가
          return false
        }
      } else {
        // 3개 이상 동일한 문자 사용 불가
        return false
      }

      const word = ['qwertyuiop', 'asdfghjkl', 'zxcvbnm']
      const wordAll = ['1234567890', ...word]
      const reverseWord = [...wordAll.map(w => [...w].reverse().join(''))]
      const keyboard = [...wordAll, ...reverseWord]

      for (let i = 0; i < pwd.length - 2; i++) {
        const sliceValue = pwd.substring(i, i + 3).toLowerCase()
        // 모든 조건을 한번씩 순회
        if (keyboard.some(code => code.includes(sliceValue))) return false
      }

      return true
    }
  })
}

/**
 * isValidDdnsPasswd
 * DNS 암호 체크
 * 1. 한글 포함 체크
 * 2. 3자 이상 32자 이하
 * 3. space 포함 체크
 * 4. 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
 * 5. 특수문자는 ~!@#$%&*()-+_ 만 가능
 * 6. 미포함해야하는 특수문자 제외 ^[]{}|\[] 등 허용된 특수문자 외 제외
 */
export const isValidDdnsPasswd = (Validator) => {
  Validator.extend('isValidDdnsPasswd', {
    getMessage: () => i18n.t('vl.isValidDdnsPasswd'),
    validate: (pwd) => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 3자 이상 32자 이하
      const len = pwd.length
      if (len < 3 || len > 33) {
        return false
      }

      // space 포함 체크
      if (pwd.indexOf(' ') >= 0) {
        return false
      }

      // 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
      // 특수문자는 ~!@#$%&*()-+_ 만 가능
      const regExp1 = /[a-z|A-Z]/
      const regExp2 = /[0-9]/
      const regExp3 = /[~|!|@|#|$|%|&|*|(|)|-|+|_|=]/
      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd)) {
        return false
      }

      // 미포함해야하는 특수문자 제외 .;^[]{}|\[] 등 허용된 특수문자 외 제외
      const regExp4 = RegExp('[\\.|\\;|\\:|\\`|\\"|\\\'|\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\\]|\\{|\\}|\\|]')
      if (regExp4.test(pwd)) {
        return false
      }

      return true
    }
  })
}

// SNMP Trap 설정 - 사용자 설정의 패스워드 규칙
// 1. 한글 포함 체크
// 2. 8자 이상 32자 이하
// 3. 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
// 4. 특수문자는 가능 -.#@=:_  (space 도 가능)
export const isValidSnmpPasswd = (Validator) => {
  Validator.extend('isValidSnmpPasswd', {
    getMessage: () => i18n.t('vl.isValidSnmpPasswd'),
    validate: pwd => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 8자 이상 32자 이하
      const len = pwd.length
      if (len < 8 || len > 33) {
        return false
      }

      // 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
      // a-z, A-Z, 0-9, 특수문자 -.#@=:_ (space 도 가능)
      const regExp1 = /[a-z|A-Z]/
      const regExp2 = /[0-9]/
      const regExp3 = /[\-.#@=:_ ]/gi

      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd)) {
        return false
      }

      // 미포함해야하는 특수문자 제외 .;^[]{}|\[] 등 허용된 특수문자 외 제외
      const regExp4 = RegExp('[\\`|\\~|\\!|\\$|\\%|\\^|\\&|\\*|\\(|\\)|\\+|\\{|\\[|\\}|\\]|\\\||\\;|\\"|\\\'|\\<|\\,|\\>|\\>|\\?|\\\\|\\/]')
      if (regExp4.test(pwd)) {
        return false
      }

      return true
    }
  })
}

// SNMP Trap 설정 - 사용자 설정의 패스워드 규칙 (CC 전용)
// 1. 한글 포함 체크
// 2. 9자 이상 32자 이하
// 3. 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
// 4. 특수문자는 가능 -.#@=:_  (space 도 가능)
export const isValidSnmpPasswdCc = (Validator) => {
  Validator.extend('isValidSnmpPasswdCc', {
    getMessage: () => i18n.t('vl.isValidSnmpPasswd'),
    validate: pwd => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 9자 이상 32자 이하
      const len = pwd.length
      if (len < 9 || len > 33) {
        return false
      }

      // 소문자,대문자,숫자,특수문자 조합 ( 반드시 4가지 종류가 다 포함되어야 함)
      // a-z, A-Z, 0-9, 특수문자 -.#@=:_ (space 도 가능)
      const regExp1 = /[a-z]/
      const regExp2 = /[A-Z]/
      const regExp3 = /[0-9]/
      const regExp4 = /[\-.#@=:_ ]/gi

      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd) || !regExp4.test(pwd)) {
        return false
      }

      // 미포함해야하는 특수문자 제외 .;^[]{}|\[] 등 허용된 특수문자 외 제외
      const regExp5 = RegExp('[\\`|\\~|\\!|\\$|\\%|\\^|\\&|\\*|\\(|\\)|\\+|\\{|\\[|\\}|\\]|\\\||\\;|\\"|\\\'|\\<|\\,|\\>|\\>|\\?|\\\\|\\/]')
      if (regExp5.test(pwd)) {
        return false
      }

      return true
    }
  })
}

// 한글 불가, 영문 + 숫자 만 가능
export const isValidEnglishAndNumbericChar = (Validator) => {
  Validator.extend('isValidEnglishAndNumbericChar', {
    getMessage: () => i18n.t('vl.isValidEnglishAndNumbericChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      // 영문 + 숫자 만 가능
      const regExp = /[^0-9a-zA-Z]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

// 한글 불가, 특수문자는 ~!@#$%&*()-+_ 만 가능
export const isValidEnglishAndSpecialChar = (Validator) => {
  Validator.extend('isValidEnglishAndSpecialChar', {
    getMessage: () => i18n.t('vl.isValidEnglishAndSpecialChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      // 특수문자는 ~!@#$%&*()-+_ 만 가능
      const regExp = /[^0-9a-zA-Z ~!@#$%&*()-+_]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

// Anonymizer 서버 목록
// 영문, 숫자, 특수문자 만 가능
export const isValidAnonymizerUrl = (Validator) => {
  Validator.extend('isValidAnonymizerUrl', {
    getMessage: () => i18n.t('vl.isValidAnonymizerUrl'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎㅏ-ㅣ가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      return true
    }
  })
}

// 영문, 숫자, -, _ , .) 만 가능
export const isValidProfileName = (Validator) => {
  Validator.extend('isValidProfileName', {
    getMessage: () => i18n.t('vl.isValidProfileName'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }
      // 영문, 숫자, -, _ , .) 만 가능
      const regExp = /[^0-9a-zA-Z-_.)]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

// 한글, 영문, 숫자, -, _, ., : 만 가능
export const isValidProfileNameAddKorea = (Validator) => {
  Validator.extend('isValidProfileNameAddKorea', {
    getMessage: () => i18n.t('vl.isValidProfileNameAddKorea'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글, 영문, 숫자, -, _, ., : 만 가능
      const regExp = /[^0-9a-zA-Z-_.:ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

// 한글, 공백, 영문, 숫자, -, _, . 만 가능
export const isValidSignatureMessage = (Validator) => {
  Validator.extend('isValidSignatureMessage', {
    getMessage: () => i18n.t('vl.isValidSignatureMessage'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글, 공백, 영문, 숫자, -, _, . 만 가능
      const regExp = /[^\s0-9a-zA-Z-_.ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

// 공백만 체크
export const isValidSpaceName = (Validator) => {
  Validator.extend('isValidSpaceName', {
    getMessage: () => i18n.t('vl.isValidSpaceName'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      return true
    }
  })
}

// 공백만 체크
export const isValidBlank = (Validator) => {
  Validator.extend('isValidBlank', {
    getMessage: () => i18n.t('vl.isValidBlank'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

// 큰따옴표(") 특수문자 입력이 불가능
export const isValidDoubleQuotes = (Validator) => {
  Validator.extend('isValidDoubleQuotes', {
    getMessage: () => i18n.t('vl.isValidDoubleQuotes'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 큰따옴표 포함 체크
      if (text.indexOf('"') >= 0) {
        return false
      }

      return true
    }
  })
}

// 슬래쉬로 시작하는지 만 체크
export const isValidSlashStart = (Validator) => {
  Validator.extend('isValidSlashStart', {
    getMessage: () => i18n.t('vl.isValidSlashStart'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 슬래쉬로 시작하는지 체크
      return _.startsWith(text, '/')
    }
  })
}

// 슬래쉬로 시작하고 마지막에 슬래쉬로 끝나지 않는지 체크
export const isValidSlashStartNoSlashEnd = (Validator) => {
  Validator.extend('isValidSlashStartNoSlashEnd', {
    getMessage: () => i18n.t('vl.isValidSlashStartNoSlashEnd'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 슬래쉬로 시작하고 마지막에 슬래쉬로 끝나지 않는지 체크
      return _.startsWith(text, '/') && !_.endsWith(text, '/')
    }
  })
}

// 한글만 체크
export const isValidKoreaChar = (Validator) => {
  Validator.extend('isValidKoreaChar', {
    getMessage: () => i18n.t('vl.isValidKoreaChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      return true
    }
  })
}

// URL 체크
export const isValidPath = (Validator) => {
  Validator.extend('isValidPath', {
    getMessage: () => i18n.t('vl.isValidPath'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      const regExPath = new RegExp('^(/)?([^/\\0]+(/)?)+$')

      if (!regExPath.test(text)) {
        return false
      }
      return true
    }
  })
}

export const isValidEmail = (Validator) => {
  Validator.extend('isValidEmail', {
    getMessage: () => i18n.t('vl.isValidEmail'),
    validate: text => {
      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      const regExPath = new RegExp('([\\w-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$')
      if (!regExPath.test(text)) {
        return false
      }
      return true
    }
  })
}

// Email과 도메인 체크
export const isValidEmailAndDomain = (Validator) => {
  Validator.extend('isValidEmailAndDomain', {
    getMessage: () => i18n.t('vl.isValidEmailAndDomain'),
    validate: text => {
      let regExPath = ''
      if (text.indexOf('@') > -1) {
        // E-mail형식체크(ex) sec*@secui.com test@secui.com)
        regExPath = new RegExp('([\\w-\\.*]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$')
      } else {
        // Domain체크(ex) secui.com)
        regExPath = new RegExp('((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$')
      }
      if (!regExPath.test(text)) {
        return false
      }
      return true
    }
  })
}

// 만료일자 체크. inputDate 가 expireDate 보다 작으면 true
// 문구는 만료일자 5년으로 설정되어 있음!
// 블랙리스트 등록 팝업에서 사용하다가 현재 사용하지 않음.
export const checkExpireDate = (Validator) => {
  Validator.extend('checkExpireDate', {
    getMessage: () => i18n.t('vl.checkExpireDate'),
    validate: (inputDate, [expireDate]) => {
      if (inputDate > expireDate) {
        return false
      }
      return true
    }
  })
}

// 장비 시각보다 이전인지 체크함. ( 에러 문구는 현재시간임을 참고!!! )
export const checkTimeBefore = (Validator) => {
  Validator.extend('checkTimeBefore', {
    getMessage: () => i18n.t('vl.checkTimeBefore'),
    validate: (inputDate, [agentTime]) => {
      if (Moment(inputDate).format('YYYY-MM-DD HH:mm:ss') < Moment(agentTime).format('YYYY-MM-DD HH:mm:ss')) {
        return false
      }
      return true
    }
  })
}

// 입력한 문자의 최소개수 체크, 기존에 사용하던 메세지와 동일하게 보완. VPN 기능에서 이용중 // TODO min 개수 메세지에 추가하는 기능 확인 필요
export const checkMinLength = (Validator) => {
  Validator.extend('checkMinLength', {
    getMessage: (prefix, [min]) => {
      return i18n.t('vl.checkMinLength', {min})
    },
    validate: (value, [min]) => {
      if (value.length < min) {
        return false
      }
      return true
    }
  })
}

// http 또는 https 를 포함하는 URL체크
export const isValidcheckUrl = (Validator) => {
  Validator.extend('isValidcheckUrl', {
    getMessage: () => i18n.t('vl.isValidcheckUrl'),
    validate: text => {
      const regExPathUrl = /^https?:\/\/([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w_\.-]*)*\/?$/
      const regExPathIpv4 = /^https?:\/\/(www\.)?(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      const regExPathIpv6 = /^https?:\/\/(www\.)?(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/
      if (!regExPathUrl.test(text) && !regExPathIpv4.test(text) && !regExPathIpv6.test(text)) {
        return false
      }
      return true
    }
  })
}

// SSLVPN > 그룹 관리 기능에서 사용하는, http 또는 https 를 포함하는 URL체크
export const isValidcheckVpnGroupUrl = (Validator) => {
  Validator.extend('isValidcheckVpnGroupUrl', {
    getMessage: () => i18n.t('vl.isValidcheckVpnGroupUrl'),
    validate: text => {
      const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/

      if (text.indexOf('http://') === 0) {
        const ipCheck = _.replace(text, 'http://', '')
        if (ipv4Regex.test(ipCheck) || ipv6Regex.test(ipCheck)) {
          return true
        }
      }
      if (text.indexOf('https://') === 0) {
        const ipCheck = _.replace(text, 'https://', '')
        if (ipv4Regex.test(ipCheck) || ipv6Regex.test(ipCheck)) {
          return true
        }
      }
      const regExPath = new RegExp('https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)')
      return regExPath.test(text)
    }
  })
}

// IPv4 또는 IPv6 또는 Domain 이면 정상 처리
export const isValidIpHostName = (Validator) => {
  Validator.extend('isValidIpHostName', {
    getMessage: () => i18n.t('vl.isValidIpHostName'),
    validate: text => {
      const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/
      const hostNameRegex = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i

      if (!ipv4Regex.test(text) && !ipv6Regex.test(text) && !hostNameRegex.test(text)) {
        return false
      }
      return true
    }
  })
}

// IPv4 또는 IPv6 또는 Domain 이면 정상 처리
export const isValidIpDomain = (Validator) => {
  Validator.extend('isValidIpDomain', {
    getMessage: () => i18n.t('vl.isValidIpDomain'),
    validate: text => {
      const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/
      const domainRegex = /^([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?$/

      if (!ipv4Regex.test(text) && !ipv6Regex.test(text) && !domainRegex.test(text)) {
        return false
      }
      return true
    }
  })
}

// IPv4 또는 Domain 이면 정상 처리
export const isValidIpv4Domain = (Validator) => {
  Validator.extend('isValidIpv4Domain', {
    getMessage: () => i18n.t('vl.isValidIpv4Domain'),
    validate: text => {
      const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      const domainRegex = /^([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?$/

      if (!ipv4Regex.test(text) && !domainRegex.test(text)) {
        return false
      }
      return true
    }
  })
}

// Vpn > IPSEC 및 터널링 기능 전용 암호 체크
// 1. 한글 포함 체크
// 2. 9자 이상 32자 이하 또는 36자 이하(parameter maxLength)
// 3. space 포함 체크
// 4. 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
// 5. 특수문자는 ~!@#$%&*()-+=_ 만 가능
// 6. 미포함해야하는 특수문자 제외 ^[]{}|\[] 등 허용된 특수문자 외 제외
// 7. 지정된 문자 사용 불가
// 8. ID와 3자리 이상 중복 불가
// 9. ID 역순의 패스워드 검사
export const isValidVpnPasswd = (Validator) => {
  Validator.extend('isValidVpnPasswd', {
    getMessage: field => i18n.t('vl.isValidVpnPasswd'),
    validate: (pwd, param) => {
      const loginId = param[0]
      const maxLength = param[1]
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 9자 이상 32자 또는 36자 이하
      const len = pwd.length
      if (len < 9 || len > maxLength) {
        return false
      }

      // space 포함 체크
      if (pwd.indexOf(' ') >= 0) {
        return false
      }

      // 영문,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
      // 특수문자는 ~!@#$%&*()-+=_ 만 가능
      const regExp1 = /[a-z|A-Z]/
      const regExp2 = /[0-9]/
      const regExp3 = /[~|!|@|#|$|%|&|*|(|)|_|+|\-|=]/
      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd)) {
        return false
      }

      // 미포함해야하는 특수문자 제외 ^[]{}|\[] 등 허용된 특수문자 외 제외
      const regExp4 = RegExp('[\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\\]|\\{|\\}|\\|\\`]')
      if (regExp4.test(pwd)) {
        return false
      }

      // 지정된 문자 사용 불가
      for (const word of reservedWord) {
        if ((pwd.toLowerCase()).indexOf(word) >= 0) {
          return false
        }
      }

      // loginId 가 없는경우에는 비밀번호 규칙에 대한 확인이 되어야 한다.
      if (loginId.length !== 0 && loginId !== '') {
        // ID와 3자리 이상 중복 불가
        for (let i = 0; i < loginId.length - 2; i++) {
          const word = loginId.substr(i, 3)
          if (pwd.indexOf(word) >= 0) {
            return false
          }
        }
        // ID 역순의 패스워드 검사
        const reverseId = loginId.split('').reverse().join('')
        return (pwd.indexOf(reverseId) < 0)
      }
      return true
    }
  })
}

// Vpn > IPSEC 및 터널링 기능 전용 암호 체크 (CC 전용)
// 1. 한글 포함 체크
// 2. 9자 이상 32자 이하 또는 36자 이하(parameter maxLength)
// 3. space 포함 체크
// 4. 소문자,대문자,숫자,특수문자 조합 ( 반드시 4가지 종류가 다 포함되어야 함)
// 5. 특수문자는 ~!@#$%&*()-+=_ 만 가능
// 6. 미포함해야하는 특수문자 제외 ^[]{}|\[] 등 허용된 특수문자 외 제외
// 7. 지정된 문자 사용 불가
// 8. ID와 3자리 이상 중복 불가
// 9. ID 역순의 패스워드 검사
export const isValidVpnPasswdCc = (Validator) => {
  Validator.extend('isValidVpnPasswdCc', {
    getMessage: field => i18n.t('vl.isValidVpnPasswd'),
    validate: (pwd, param) => {
      const loginId = param[0]
      const maxLength = param[1]
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 9자 이상 32자 또는 36자 이하
      const len = pwd.length
      if (len < 9 || len > maxLength) {
        return false
      }

      // space 포함 체크
      if (pwd.indexOf(' ') >= 0) {
        return false
      }

      // 소문자,대문자,숫자,특수문자 조합 ( 반드시 4가지 종류가 다 포함되어야 함)
      // 특수문자는 ~!@#$%&*()-+=_ 만 가능
      const regExp1 = /[a-z]/
      const regExp2 = /[A-Z]/
      const regExp3 = /[0-9]/
      const regExp4 = /[~|!|@|#|$|%|&|*|(|)|_|+|\-|=]/
      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd) || !regExp4.test(pwd)) {
        return false
      }

      // 미포함해야하는 특수문자 제외 ^[]{}|\[] 등 허용된 특수문자 외 제외
      const regExp5 = RegExp('[\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\\]|\\{|\\}|\\|\\`]')
      if (regExp5.test(pwd)) {
        return false
      }

      // 지정된 문자 사용 불가
      for (const word of reservedWord) {
        if ((pwd.toLowerCase()).indexOf(word) >= 0) {
          return false
        }
      }

      // loginId 가 없는경우에는 비밀번호 규칙에 대한 확인이 되어야 한다.
      if (loginId.length !== 0 && loginId !== '') {
        // ID와 3자리 이상 중복 불가
        for (let i = 0; i < loginId.length - 2; i++) {
          const word = loginId.substr(i, 3)
          if (pwd.indexOf(word) >= 0) {
            return false
          }
        }
        // ID 역순의 패스워드 검사
        const reverseId = loginId.split('').reverse().join('')
        return (pwd.indexOf(reverseId) < 0)
      }
      return true
    }
  })
}

// 영문으로 시작하고 영문/숫자/ - . _ 특수문자만 허용
export const isValidLinkageServerId = (Validator) => {
  Validator.extend('isValidLinkageServerId', {
    getMessage: () => i18n.t('vl.isValidLinkageServerId'),
    validate: (id) => {
      const idReg = /^[a-zA-Z]+[a-zA-Z0-9\-._]*$/g
      if (!idReg.test(id)) {
        return false
      }
      return true
    }
  })
}
// 첫글자는 영문으로 시작하고, 영문/숫자만 가능함. 4~32자리, 3개의 특수문자 허용 (.-_)
// E-Mail 형식
export const isValidLoginIdOrMail = (Validator) => {
  Validator.extend('isValidLoginIdOrMail', {
    getMessage: () => i18n.t('vl.isValidLinkageServerId'),
    validate: (value) => {
      const idReg = /^[a-zA-Z]+[a-zA-Z0-9|\-|.|_]{3,31}$/g
      const regExPath = new RegExp('([\\w-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,6}|[0-9]{1,3})(\\]?)$')

      if (!idReg.test(value) && !regExPath.test(value)) {
        return false
      }

      return true
    }
  })
}

// 영문으로 시작하고 영문/숫자/ - . _ @ 특수문자만 허용
export const isValidAuthUserId = (Validator) => {
  Validator.extend('isValidAuthUserId', {
    getMessage: () => i18n.t('vl.isValidAuthUserId'),
    validate: (id) => {
      const idReg = /^[a-zA-Z]+[a-zA-Z0-9\-._@]*$/g
      if (!idReg.test(id)) {
        return false
      }
      return true
    }
  })
}

// SNMP 설정 - 커뮤니티 이름 조건 ( a-z, A-Z, 0-9, "_." )
export const isValidCommunityName = (Validator) => {
  Validator.extend('isValidCommunityName', {
    getMessage: () => i18n.t('vl.isValidCommunityName'),
    validate: (id) => {
      const idReg = /^[a-zA-Z]+[a-zA-Z0-9._]*$/g
      if (!idReg.test(id)) {
        return false
      }
      return true
    }
  })
}

// SNMP 설정 - 커뮤니티 이름 조건 ( a-z, A-Z, 0-9, "_." )
// (최소 10자리 이상, 영문/숫자 조합) -> #31971 에 의해 변경됨 -> (1자 이상 32자 이하 영문, 숫자, 특수문자 만 가능)
export const isValidCommunityNameSecui = (Validator) => {
  Validator.extend('isValidCommunityNameSecui', {
    getMessage: () => i18n.t('vl.isValidCommunityNameSecui'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 공백 체크
      const emptyExp = /\s/g
      if (emptyExp.test(text)) {
        return false
      }
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎㅏ-ㅣ가-힣]/
      if (regExpKor.test(text)) {
        return false
      }
      // 1자 이상 32자 이하
      const len = text.length
      if (len < 1 || len > 32) {
        return false
      }
      return true
    }
    // validate: (id) => {
    //   // 10자 이상
    //   if (id.length < 10) {
    //     return false
    //   }
    //
    //   // 영문,숫자 조합 ( 반드시 2가지 종류가 다 포함되어야 함)
    //   // 특수문자는 ~!@#$%&*()-+=_ 만 가능
    //   const regExp1 = /[a-z|A-Z]/
    //   const regExp2 = /[0-9]/
    //   if (!regExp1.test(id) || !regExp2.test(id)) {
    //     return false
    //   }
    //
    //   // 허용 문제 외 다른 문자가 있으면 안됨.
    //   const idReg = /^[a-zA-Z]+[a-zA-Z0-9._]*$/g
    //   if (!idReg.test(id)) {
    //     return false
    //   }
    //   return true
    // }
  })
}

// 출발지/목적지 포트 유효성 검사
// 단일 : 0 ~ 65535
// 범위 : 단일값:단일값, 단일값:, :단일값   ( 1:1024 > 1~1024, 10000: > 10000 이상, :1024 > 1024이하 )
// 혼합 : 총 ~개의 단일값, 범위값을 콤마로 구분, MAX 10개
export const isValidUserDefinePort = (Validator) => {
  Validator.extend('isValidUserDefinePort', {
    getMessage: () => i18n.t('vl.isValidPort'),
    validate: (value) => {
      const portRegex = /^(?:(?:\d{1,5}\:|\:\d{1,5}|\d{1,5}\:\d{1,5}|\d{1,5})(\,(?:\d{1,5}\:|\:\d{1,5}|\d{1,5}\:\d{1,5}|\d{1,5})){0,9})$/
      if (!portRegex.test(value)) {
        return false
      }

      const
        portStrArr = value.split(','),
        maxPort = 65535
      // const maxPort = (protocol === '2' ? 255 : 65535)
      for (let i = 0, max = portStrArr.length; i < max; i++) {
        if (portStrArr[i].indexOf(':') !== -1) {
          const
            portArr = portStrArr[i].split(':'),
            port1 = portArr[0],
            port2 = portArr[1],
            num1 = (_.size(port1) === 0) ? NaN : Number(portArr[0]),
            num2 = (_.size(port2) === 0) ? NaN : Number(portArr[1])
          if (_.isNaN(num1) && (num2 > maxPort || num2 < 0)) {
            return false
          } else if (_.isNaN(num2) && (num1 > maxPort || num1 < 0)) {
            return false
          } else if (num1 > maxPort || num1 < 0 || num2 > maxPort || num2 < 0 || num1 > num2) {
            return false
          }
        } else {
          const num = Number(portStrArr[i])
          if (num > maxPort || num < 0) {
            return false
          }
        }
      }
      return true
    }
  })
}

// 정책 출발지 포트 유효성 검사
// 단일 : *, 0 ~ 65535
export const isValidPolicyStartPort = (Validator) => {
  Validator.extend('isValidPolicyStartPort', {
    getMessage: () => i18n.t('vl.isValidPort'),
    validate: (value) => {
      // 특수문자는 * 포함 가능
      if (value === '*') {
        return true
      }

      // 숫자 포함 가능
      const idRegex = /^[0-9|]{1,}$/
      if (!idRegex.test(value)) {
        return false
      }

      if (value > 65535 || value < 0) {
        return false
      }
      return true
    }
  })
}

// space 포함 체크
export const isValidSpace = (Validator) => {
  Validator.extend('isValidSpace', {
    getMessage: () => i18n.t('vl.isValidSpace'),
    validate: (text) => {
      if (text.indexOf(' ') >= 0) {
        return false
      }
      return true
    }
  })
}

// 숫자만 가능
export const isOnlyNumber = (Validator) => {
  Validator.extend('isOnlyNumber', {
    getMessage: () => i18n.t('vl.isOnlyNumber'),
    validate: (text) => {
      const regExp = /^[0-9]*$/
      if (!regExp.test(text)) {
        return false
      }
      return true
    }
  })
}

// 숫자, - 만 가능
export const isOnlyNumberHyphen = (Validator) => {
  Validator.extend('isOnlyNumberHyphen', {
    getMessage: () => i18n.t('vl.isOnlyNumberHyphen'),
    validate: (text) => {
      const regExp = /^[0-9-]*$/
      if (!regExp.test(text)) {
        return false
      }
      return true
    }
  })
}

// 영문, 숫자로 시작하고 영문, 숫자, -, _  만 가능
export const isValidVSName = (Validator) => {
  Validator.extend('isValidVSName', {
    getMessage: () => i18n.t('vl.isValidVSName'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }
      // 영문, 숫자로 시작하고 영문, 숫자, -, _  만 가능
      const regExp = /^[a-zA-Z0-9]+[a-zA-Z0-9\-_]*$/g
      if (!regExp.test(text)) {
        return false
      }
      return true
    }
  })
}

//
/**
 * isValidDNSDomain
 * SPLIT DNS zone 추가
 * alphabetic & digits 0 through 9 & hyphen & dot
 * Label당 최대 길이는 63자 이하
 */
export const isValidDNSDomain = (Validator) => {
  Validator.extend('isValidDNSDomain', {
    getMessage: () => i18n.t('vl.isValidDNSDomain'),
    validate: text => {
      // RFC 952
      const domainRegex = /^([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9]))*$/
      if (!domainRegex.test(text)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidReservedWord
 * "ANY, ORG, DYNAMIC_IP, MULTILINE, NONE" Word
 */
export const isValidReservedWord = (Validator) => {
  Validator.extend('isValidReservedWord', {
    getMessage: () => i18n.t('vl.isValidReservedWord'),
    validate: text => {
      if (typeof text === 'string') {
        text = text.trim()
      }
      const reservedWordRegex = /^any$|^org$|^dynamic_ip$|^multiline$|^none$/i
      if (reservedWordRegex.test(text)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidTimeReservedWord
 * "ANY" Word
 */
export const isValidTimeReservedWord = (Validator) => {
  Validator.extend('isValidTimeReservedWord', {
    getMessage: () => i18n.t('vl.isValidTimeReservedWord'),
    validate: text => {
      if (typeof text === 'string') {
        text = text.trim()
      }
      const reservedWordRegex = /^any$/i
      if (reservedWordRegex.test(text)) {
        return false
      }
      return true
    }
  })
}

/**
 * Host of ddns 이름 규칙
 * 영문, 숫자, .
 */
export const isValidDdnsHostName = (Validator) => {
  Validator.extend('isValidDdnsHostName', {
    getMessage: () => i18n.t('vl.isValidDdnsHostName'),
    validate: (id) => {
      // 영문, 숫자, . 만 가능
      const regExp = /[^\s0-9a-zA-Z.]/gi
      if (regExp.test(id)) {
        return false
      }
      const emptyExp = /\s/g
      if (emptyExp.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * Host of ddns 이름 규칙
 * 영문, 숫자, 한글
 */
export const isValidDdnsHostId = (Validator) => {
  Validator.extend('isValidDdnsHostId', {
    getMessage: () => i18n.t('vl.isValidDdnsHostId'),
    validate: (id) => {
      // 영문, 숫자, 한글만 가능
      const regExp = /[^\s0-9a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(id)) {
        return false
      }
      const emptyExp = /\s/g
      if (emptyExp.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * Host of dhcp macAddress 이름 규칙
 * 영문, 숫자, -, _
 */
export const isValidDhcpMacHostName = (Validator) => {
  Validator.extend('isValidDhcpMacHostName', {
    getMessage: () => i18n.t('vl.isValidDhcpMacHostName'),
    validate: (id) => {
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(id)) {
        return false
      }
      // 영문, 숫자, -, _  만 가능
      const regExp = /[^0-9a-zA-Z-_]/gi
      if (regExp.test(id)) {
        return false
      }

      return true
    }
  })
}

/**
 * isValidateProtocolName
 * 영문, 한글, 숫자와 다음 특수 문자만 입력할 수 있습니다.(., _, -)
 */
export const isValidProtocolName = (Validator) => {
  Validator.extend('isValidProtocolName', {
    getMessage: () => i18n.t('vl.isValidProtocolName'),
    validate: text => {
      if (!text) {
        return false
      }

      const regExp = /[^0-9a-zA-Z ._-ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(text)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidProtocolName
 * 프로토콜 이름은 숫자만 입력할 수 없습니다.
 */
export const isValidOnlyNumberProtocolName = (Validator) => {
  Validator.extend('isValidOnlyNumberProtocolName', {
    getMessage: () => i18n.t('vl.isValidOnlyNumberProtocolName'),
    validate: (text) => {
      const regExpNum = /^[0-9]*$/
      if (regExpNum.test(text)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidRangePort
 * 값이 없거나, * 이면 True
 * Port의 범위에 대한 중복 체크
 */
export const isValidRangePort = (Validator) => {
  Validator.extend('isValidRangePort', {
    getMessage: () => i18n.t('vl.isValidRangePort'),
    validate: (text) => {
      const portRegex = /^(?:\*|(?:(?:\d{1,5}\-\d{1,5}|\d{1,5})(\,(?:\d{1,5}\-\d{1,5}|\d{1,5})){0,9}))$/
      if (!portRegex.test(text) || text === '*' || text === '') {
        return true
      }
      const ports = text.split(',')
      if (ports.length < 1) {
        return true
      }

      let isValid = true

      const checkPortType = (port) => { // single, range
        if (/^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/.test(port)) { // singleType
          return 'single'
        }
        if (/^((?:\d{1,5}\-\d{1,5}|\d{1,5})){0,9}$/.test(port)) { // rangeType
          return 'range'
        }
      }

      const comparePorts = () => {
        const portItem = ports.pop()
        const portItemType = checkPortType(portItem)
        for (let i = 0, l = ports.length; i < l; i++) {
          const compareItem = ports[i]
          const compareItemType = checkPortType(compareItem)
          if (portItemType === 'single' && compareItemType === 'single') {
            compareSingleToSingle(portItem, compareItem)
          } else if (portItemType === 'single' && compareItemType === 'range') {
            compareSingleToRange(portItem, compareItem)
          } else if (portItemType === 'range' && compareItemType === 'single') {
            compareSingleToRange(compareItem, portItem)
          } else if (portItemType === 'range' && compareItemType === 'range') {
            compareRangeToRange(portItem, compareItem)
          }
        }
      }

      const compareSingleToSingle = (a, b) => {
        if (a === b) {
          isValid = false
        }
      }

      const compareSingleToRange = (a, b) => {
        const bMin = Number(b.split('-')[0])
        const bMax = Number(b.split('-')[1])
        if (bMin <= a && bMax >= a) {
          isValid = false
        }
      }

      const compareRangeToRange = (a, b) => {
        const aMin = Number(a.split('-')[0])
        const aMax = Number(a.split('-')[1])
        const bMin = Number(b.split('-')[0])
        const bMax = Number(b.split('-')[1])

        if ((aMin <= bMin && aMax >= bMin) || (aMin <= bMax && aMax >= bMax)) {
          isValid = false
        }
        if ((bMin <= aMin && bMax >= aMin) || (bMin <= aMax && bMax >= aMax)) {
          isValid = false
        }
      }

      while (ports.length) {
        comparePorts()
        if (isValid === false) {
          return isValid // false
        }
      }
      return isValid // true
    }
  })
}

/**
 * isValidVlanId
 * 정책 Vlan Id 유효성 검증
 */
export const isValidVlanId = (Validator) => {
  Validator.extend('isValidVlanId', {
    getMessage: () => i18n.t('vl.isValidVlanId'),
    validate: (value) => {
      if (value !== '' &&
        value !== void 0 &&
        value !== null) {
        let regex = /^(\d{1,4})(?:\,(\d{1,4})){0,59}$/
        let checkVlandRange = false

        if (!regex.test(value)) {
          return false
        }

        let arrValue = value.split(',')

        if (_.uniq(arrValue).length !== arrValue.length) {
          return false
        }

        _.forEach(arrValue, (vlanId) => {
          if (Number(vlanId) < 1 || Number(vlanId) > 4094) {
            checkVlandRange = true
          }
        })

        if (checkVlandRange) {
          return false
        }
      }

      return true
    }
  })
}

/**
 * isValidDeviceAlias
 * 영문, 한글, 숫자와 다음 특수 문자만 입력할 수 있습니다.(_, -)
 */
export const isValidDeviceAlias = (Validator) => {
  Validator.extend('isValidDeviceAlias', {
    getMessage: () => i18n.t('vl.isValidDeviceAlias'),
    validate: text => {
      if (!text) {
        return false
      }

      const regExp = /[^0-9a-zA-Z _\-ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(text)) {
        return false
      }
      return true
    }
  })
}

// 6자 이상 32자 이하 한글, 영문, 숫자, -, _만 가능
export const isValidVpnId = (Validator) => {
  Validator.extend('isValidVpnId', {
    getMessage: () => i18n.t('vl.isValidVpnId'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글, 영문, 숫자, -, _만 가능
      const regExp = /[^0-9a-zA-Z-_ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(text)) {
        return false
      }

      // 6자 이상 32자 이하
      const len = text.length
      if (len < 6 || len > 32) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

// 6자 이상 32자 이하 영문, 숫자, -, _, ., :만 가능
export const isValidVpnIdNoKor = (Validator) => {
  Validator.extend('isValidVpnIdNoKor', {
    getMessage: () => i18n.t('vl.isValidVpnIdNoKor'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 영문, 숫자, -, _, ., :만 가능
      const regExp = /[^0-9a-zA-Z-_.:\-]/gi
      if (regExp.test(text)) {
        return false
      }

      // 6자 이상 32자 이하
      const len = text.length
      if (len < 6 || len > 32) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

// 6자 이상 32자 이하 영문, 숫자, 특수문자 만 가능
export const isValidVpnNoKorAllChar = (Validator) => {
  Validator.extend('isValidVpnNoKorAllChar', {
    getMessage: () => i18n.t('vl.isValidVpnNoKorAllChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 공백 체크
      const emptyExp = /\s/g
      if (emptyExp.test(text)) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      // 6자 이상 32자 이하
      const len = text.length
      if (len < 6 || len > 32) {
        return false
      }

      return true
    }
  })
}

// 32자 이하 한글, 영문, 숫자, -, _만 가능
export const isValidVpnId32 = (Validator) => {
  Validator.extend('isValidVpnId32', {
    getMessage: () => i18n.t('vl.isValidVpnId32'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글, 영문, 숫자, -, _만 가능
      const regExp = /[^0-9a-zA-Z-_ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(text)) {
        return false
      }

      // 32자 이하
      const len = text.length
      if (len > 32) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

// 32자 이하 영문, 숫자, -, _만 가능
export const isValidVpnId32NoKor = (Validator) => {
  Validator.extend('isValidVpnId32NoKor', {
    getMessage: () => i18n.t('vl.isValidVpnId32NoKor'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 영문, 숫자, -, _만 가능
      const regExp = /[^0-9a-zA-Z-_\-]/gi
      if (regExp.test(text)) {
        return false
      }

      // 32자 이하
      const len = text.length
      if (len > 32) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

// 32자 이하 영문, 숫자, 특수문자 만 가능
export const isValidVpnId32NoKorAllChar = (Validator) => {
  Validator.extend('isValidVpnId32NoKorAllChar', {
    getMessage: () => i18n.t('vl.isValidVpnId32NoKorAllChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 공백 체크
      const emptyExp = /\s/g
      if (emptyExp.test(text)) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎㅏ-ㅣ가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      // 32자 이하
      const len = text.length
      if (len > 32) {
        return false
      }

      return true
    }
  })
}

// 48자 이하 한글, 영문, 숫자, -, _만 가능
export const isValidVpnId48 = (Validator) => {
  Validator.extend('isValidVpnId48', {
    getMessage: () => i18n.t('vl.isValidVpnId48'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글, 영문, 숫자, -, _만 가능
      const regExp = /[^0-9a-zA-Z-_ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(text)) {
        return false
      }

      // 48자 이하
      const len = text.length
      if (len > 48) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

// 32자 이하 영문, 숫자, -, _, ., :만 가능
export const isValidVpnBranchId32NoKor = (Validator) => {
  Validator.extend('isValidVpnBranchId32NoKor', {
    getMessage: () => i18n.t('vl.isValidVpnBranchId32NoKor'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 영문, 숫자, -, _, ., :만 가능
      const regExp = /[^0-9a-zA-Z-_.:\-]/gi
      if (regExp.test(text)) {
        return false
      }

      // 32자 이하
      const len = text.length
      if (len > 32) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

/**
 * 시스템정보>설정>장비 이름 규칙(info/equipment-hostname)
 * 영문, 숫자, 특수문자 : ._- 3개만 허용
 * 한글 불가
 */
export const isValidEquipmentHostName = (Validator) => {
  Validator.extend('isValidEquipmentHostName', {
    getMessage: () => i18n.t('vl.isValidEquipmentHostName'),
    validate: (text) => {
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      // 특수문자는  만 가능
      const regExp = /[^0-9a-zA-Z._\-]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

/**
 * Host of dnszone E-mail 규칙
 * 영문, 숫자, .
 */
export const isValidDnsHostEmail = (Validator) => {
  Validator.extend('isValidDnsHostEmail', {
    getMessage: () => i18n.t('vl.isValidDnsHostEmail'),
    validate: (id) => {
      // 영문, 숫자, . 만 가능
      const regExp = /[^\s0-9a-zA-Z.]/gi
      if (regExp.test(id)) {
        return false
      }
      const emptyExp = /\s/g
      if (emptyExp.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidDomain
 * ex) secui.com 형식 지원
 */
export const isValidDomain = (Validator) => {
  Validator.extend('isValidDomain', {
    getMessage: () => i18n.t('vl.isValidDomain'),
    validate: (val) => {
      const idRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,251}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/
      if (!idRegex.test(val)) {
        return false
      }
      return true
    }
  })
}

/**
 * name of routingPolicyTable 이름 규칙
 * 한글, 영문, 숫자, 특수문자(_)
 * validate msg -> vl.isValidRoutPolicyTableName(br)
 * ui tooltip -> msg.notiMsgRoutPolicyTableName(\n)
 */
const reservedTblName = ['main', 'default', 'local']
export const isValidRoutPolicyTableName = (Validator) => {
  Validator.extend('isValidRoutPolicyTableName', {
    getMessage: () => i18n.t('vl.isValidRoutPolicyTableName'),
    validate: (id) => {
      // 영문, 숫자, 한글, _만 가능
      const regExp = /[^\s0-9a-zA-Z_ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(id)) {
        return false
      }
      const emptyExp = /\s/g
      if (emptyExp.test(id)) {
        return false
      }
      // 지정된 문자 사용 불가(대소문자 구분 - 소문자 사용불가)
      for (const word of reservedTblName) {
        if (id === word) {
          return false
        }
      }
      return true
    }
  })
}

/**
 * name of vriRoutingPolicyTable 이름 규칙
 * 한글, 영문, 숫자, 특수문자(_)
 * validate msg -> vl.isValidVriRoutPolicyTableName(br)
 * ui tooltip -> msg.notiMsgVriRoutPolicyTableName(\n)
 */
export const isValidVriRoutPolicyTableName = (Validator) => {
  Validator.extend('isValidVriRoutPolicyTableName', {
    getMessage: () => i18n.t('vl.isValidVriRoutPolicyTableName'),
    validate: (id) => {
      // 영문, 숫자, 한글, _만 가능
      const regExp = /[^\s0-9a-zA-Z_ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(id)) {
        return false
      }
      const emptyExp = /\s/g
      if (emptyExp.test(id)) {
        return false
      }
      // 숫자만 입력 불가
      const regExpNum = /^[0-9]*$/
      if (regExpNum.test(id)) {
        return false
      }
      // 지정된 문자 사용 불가(대소문자 구분 - 소문자 사용불가)
      for (const word of reservedTblName) {
        if (id === word) {
          return false
        }
      }
      return true
    }
  })
}

/**
 * 스트링 사용자 이름 규칙isValidStringUserName
 * 한글, 영문, 숫자, 특수문자(._-\)
 */
export const isValidStringUserName = (Validator) => {
  Validator.extend('isValidStringUserName', {
    getMessage: () => i18n.t('vl.isValidStringUserName'),
    validate: (value) => {
      // 문자, 숫자, 한글, ._-\만 가능
      const regExp = /[^\sㄱ-ㅎㅏ-ㅣ가-힣0-9a-zA-Z\\._-]/gi

      if (regExp.test(value)) {
        return false
      }

      let valueArr = value.split('\\')

      if (valueArr.length === 1) {
        if (/^[\s]|[\s]$/g.test(valueArr[0])) {
          // 사용자 ID 앞뒤로 공백 확인
          return false
        }
      } else if (valueArr.length === 2) {
        if (/\s/g.test(valueArr[0])) {
          // 도메인에 공백 포함여부 확인
          return false
        } else if (/^[\s]|[\s]$/g.test(valueArr[1])) {
          // 사용자 ID 앞뒤로 공백 확인
          return false
        } else if (valueArr.length === 2 && valueArr[1] === '') {
          // \ 뒤 공백 일 경우
          return false
        }
      } else {
        return false
      }

      return true
    }
  })
}

/**
 * Virtaual System Topology VS 예약어 체크
 * VS Topology VSI Reserved Word('base_vsi', 'base_vri_vwi', 'vsi0', 'physical', 'ha') 사용 불가 체크
 */
const vsiReservedWord = ['base_vsi', 'base_vri_vwi', 'vsi0', 'physical', 'ha']
export const isValidVsiReservedWord = (Validator) => {
  Validator.extend('isValidVsiReservedWord', {
    getMessage: () => i18n.t('vl.isValidVsiReservedWord'),
    validate: (inputStr) => {
      // 지정된 문자 사용 불가
      for (const word of vsiReservedWord) {
        if (inputStr.toLowerCase() === word) {
          return false
        }
      }
      return true
    }
  })
}

/**
 * isValidUserDomain
 * 영문, 숫자와 다음 특수 문자만 입력할 수 있습니다.(_, -), 32자 이하
 */
export const isValidUserDomain = (Validator) => {
  Validator.extend('isValidUserDomain', {
    getMessage: () => i18n.t('vl.isValidUserDomain'),
    validate: text => {
      if (!text) {
        return false
      }

      const regExp = /[^0-9a-zA-Z_-]/gi
      if (regExp.test(text)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidWmiId
 * 영문, 숫자와 다음 특수 문자만 입력할 수 있습니다.(_, -, \), 32자 이하
 */
export const isValidWmiId = (Validator) => {
  Validator.extend('isValidWmiId', {
    getMessage: () => i18n.t('vl.isValidWmiId'),
    validate: text => {
      if (!text) {
        return false
      }

      const regExp = /[^0-9a-zA-Z\\_-]/gi
      if (regExp.test(text)) {
        return false
      }
      return true
    }
  })
}

// IPv4, IPv6 또는 Domain 이면 정상 처리
export const isValidIpv46Domain = (Validator) => {
  Validator.extend('isValidIpv46Domain', {
    getMessage: () => i18n.t('vl.isValidIpv46Domain'),
    validate: text => {
      const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/
      const domainRegex = /^([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?$/

      if (!ipv4Regex.test(text) && !domainRegex.test(text) && !ipv6Regex.test(text)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidBackupPasswd
 * 1자 ~ 32자, 영문, 숫자, 특수문자(~ ! @ # % * ( ) - + = _) 혼합으로 이루어져야 합니다.
 * 금지 특수문자 : ` $ ^ & { } [ ] \ | ; ' : " , / < > ?
 */
export const isValidBackupPasswd = (Validator) => {
  Validator.extend('isValidBackupPasswd', {
    getMessage: () => i18n.t('vl.isValidPasswd'),
    validate: (password) => {
      const pwRegex = /^.*(?=^.{1,32}$)(?=.*\d)(?=.*[a-zA-Z0-9])(?=.*[~!@#%*()\-+=_]).*$/
      if (!pwRegex.test(password)) {
        return false
      }

      // 금지 특수문자 : ` $ ^ & { } [ ] \ | ; ' : " , / < > ?
      const regExp2 = RegExp('[\\`|\\$|\\^|\\&|\\{|\\}|\\[|\\]|\\\\|\\\||\\;|\\\'|\\:|\\\"|\\,|\\/|\\<|\\>|\\?|\\.]')
      if (regExp2.test(password)) {
        return false
      }

      return true
    }
  })
}

// 32자 이하 한글, 영문, 숫자, 특수문자만 가능
export const isValidKorId = (Validator) => {
  Validator.extend('isValidKorId', {
    getMessage: () => i18n.t('vl.isValidKorId'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글, 영문, 숫자, -, _, \ 만 가능
      // const regExp = /[^0-9a-zA-Z-_\\ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      // if (regExp.test(text)) {
      //   return false
      // }

      // 32자 이하
      const len = text.length
      if (len > 32) {
        return false
      }

      // space 포함 체크
      if (text[0] === ' ' || text[text.length - 1] === ' ') {
        return false
      }

      return true
    }
  })
}

// 2~4094, 최대 50개(콤마로 구분)
export const isValidVid = (Validator) => {
  Validator.extend('isValidVid', {
    getMessage: () => i18n.t('vl.isValidVid'),
    validate: (text) => {
      const regExp = /^[0-9,]*$/
      if (!regExp.test(text)) {
        return false
      }
      const vidStrArr = text.split(',')
      if (vidStrArr.length > 50) {
        return false
      }
      for (let i = 0; i < vidStrArr.length; i++) {
        const vid = Number(vidStrArr[i])
        if (_.isNaN(vid) || vid < 2 || vid > 4094) {
          return false
        }
      }
      return true
    }
  })
}

// 리눅스 사용자 ID 정규식
export const isValidLinuxId = (Validator) => {
  Validator.extend('isValidLinuxId', {
    getMessage: () => i18n.t('vl.isValidLinuxId'),
    validate: (text) => {
      const regExp = /^[a-zA-Z0-9._]([a-zA-Z0-9._-]{0,31}|[a-zA-Z0-9._-]{0,30}\$)$/
      if (!regExp.test(text)) {
        return false
      }

      if (text.indexOf('$') >= 0) {
        return false
      }

      // 최소 1개 이상의 영문이 포함되어야 함.
      const regExp2 = /[a-z|A-Z]/
      if (!regExp2.test(text)) {
        return false
      }

      return true
    }
  })
}

// system/pppoe id, password (영문, 숫자, 특수문자), [;, |, &, `, $] 사용불가
export const isValidPPPoeIdPwd = (Validator) => {
  Validator.extend('isValidPPPoeIdPwd', {
    getMessage: () => i18n.t('vl.isValidPPPoeIdPwd'),
    validate: text => {
      // 입력값 없음 체크
      if (text === undefined || text === null) {
        return false
      }
      // 공백 체크
      const emptyExp = /\s/g
      if (emptyExp.test(text)) {
        return false
      }
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }
      // 특수문자 사용불가 체크
      const regExp = RegExp('[\\;|\\\||\\&|\\`|\\$]')
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

// 최대 입력 개수는 10개 입니다.
export const isValidTenCount = (Validator) => {
  Validator.extend('isValidTenCount', {
    getMessage: () => i18n.t('vl.isValidTenCount'),
    validate: (text) => {
      if (!text || typeof text !== 'string') return true
      const count = text.split(',').length
      if (count > 10) {
        return false
      }
      return true
    }
  })
}

// 소수점 1자리 까지만 입력할 수 있습니다.
export const isValidVsiLogDisk = (Validator) => {
  Validator.extend('isValidVsiLogDisk', {
    getMessage: () => i18n.t('vl.isValidVsiLogDisk'),
    validate: (text) => {
      const regExp = /^\d+(?:[.]?[\d])?$/
      if (!regExp.test(text)) {
        return false
      }
      return true
    }
  })
}

// 2자 이상 64자 이하의 영문, 숫자, 특수문자만 입력할 수 있습니다.
export const isValidSignatureOpt = (Validator) => {
  Validator.extend('isValidSignatureOpt', {
    getMessage: () => i18n.t('vl.isValidSignatureOpt'),
    validate: (text) => {
      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎㅏ-ㅣ가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      // 9자 이상 32자 이하
      const len = _.get(text, ['length'], 0)
      if (len < 2 || len > 64) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidIPv4IPv6, / Netmask 미포함.
 * 쉼표로 구분된 여러 IP를 검증. IPv4, v6 가능.
 */
export const isValidIPv4IPv6NoNetMask = (Validator) => {
  Validator.extend('isValidIPv4IPv6NoNetMask', {
    getMessage: () => i18n.t('vl.isValidIPv4IPv6NoNetMask'),
    validate: (ipList) => {
      if (ipList.length > 0) {
        ipList = ipList.replace(' ', '')
        // 쉼표로 구분된 IP 분리
        const ipAllList = ipList.split(',')
        const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]|[1-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]|[1-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]|[1-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]|[1-9][0-9]?)$/
        // IPv6 정규식 조금 다름 ( IPv4-Embedded IPv6 Address 막도록 변경 )
        const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4})$/

        // 반복문으로 각 IP 체크
        for (let i = 0, max = ipAllList.length; i < max; i++) {
          // 유효성 검사를 통과하지 못하면 return false
          // if (ipAllList[i].indexOf('/') > -1 && ipAllList[i].indexOf('-') > -1) {
          //   return false
          // }
          if (ipAllList[i].indexOf('/') > -1) {
            return false
          } else {
            let ipTxt = ipAllList[i].split('-')
            if (ipTxt.length > 2) {
              return false
            } else if (!(ipv4Regex.test(ipTxt[0]) || ipv6Regex.test(ipTxt[0]))) {
              return false
            } else if (ipTxt.length === 2 && !(ipv4Regex.test(ipTxt[1]) || ipv6Regex.test(ipTxt[1]))) {
              return false
            } else if (ipTxt.length === 2 &&
              !((ipv4Regex.test(ipTxt[0]) && ipv4Regex.test(ipTxt[1])) || (ipv6Regex.test(ipTxt[0]) && ipv6Regex.test(ipTxt[1])))) {
              return false
            } else if (ipTxt.length === 2) {
              const iIp1 = parseInt(ipTxt[0].replace(/\.|:/g, ''), 16)
              const iIp2 = parseInt(ipTxt[1].replace(/\.|:/g, ''), 16)

              if (isNaN(iIp1) || isNaN(iIp2) || iIp1 >= iIp2) {
                return false
              }
            }
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * isValidWindowPath
 * 128자 이하 "C:\\Windows\\notepad.exe" 형식의 절대 경로를 입력 (구분: \\)
 */
export const isValidWindowPath = (Validator) => {
  Validator.extend('isValidWindowPath', {
    getMessage: field => i18n.t('vl.isValidWindowPath'),
    validate: (text) => {
      if (text === undefined || text === null) {
        return false
      }

      // 한글 포함 체크
      const regWindowPath = /^[a-zA-Z]:\\\\(?:[^\\\\/:*?"<>|\r\n]+\\\\)*[^\\\\/:*?"<>|\r\n]*$/
      if (!regWindowPath.test(text)) {
        return false
      }

      const len = text.length
      if (len > 128) {
        return false
      }

      return true
    }
  })
}

/**
 * isValidUnixPath
 * 128자 이하 "/usr/me/help.d" 형식의 절대 경로를 입력 (구분: /)
 */
export const isValidUnixPath = (Validator) => {
  Validator.extend('isValidUnixPath', {
    getMessage: field => i18n.t('vl.isValidUnixPath'),
    validate: (text) => {
      if (text === undefined || text === null) {
        return false
      }

      // 한글 포함 체크
      const regUnixPath = /^(?:\/[^/]+)*$/
      if (!regUnixPath.test(text)) {
        return false
      }

      const len = text.length
      if (len > 128) {
        return false
      }

      return true
    }
  })
}

// 3자 이상 16자 이하 영문, 숫자 만 가능
export const isValidVpnIfLineNoKor = (Validator) => {
  Validator.extend('isValidVpnIfLineNoKor', {
    getMessage: () => i18n.t('vl.isValidVpnIfLineNoKor'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 공백 체크
      const emptyExp = /\s/g
      if (emptyExp.test(text)) {
        return false
      }

      // 6자 이상 32자 이하
      const len = text.length
      if (len < 3 || len > 16) {
        return false
      }

      // 영문, 숫자만 가능
      const regExp = /[^0-9a-zA-Z]/gi
      if (regExp.test(text)) {
        return false
      }

      // 영문 + 숫자만 가능
      const numExp = /[0-9]/gi
      const charExp = /[a-zA-Z]/gi
      if (numExp.test(text) && charExp.test(text)) {
        return true
      } else {
        return false
      }
    }
  })
}

// 특정 IP를 입력할 수 없습니다. (0.0.0.0)
export const isValidNotSpecialIp = (Validator) => {
  Validator.extend('isValidNotSpecialIp', {
    getMessage: () => i18n.t('vl.isValidNotSpecialIp'),
    validate: (text) => {
      if (text === '0.0.0.0') {
        return false
      }
      return true
    }
  })
}

// 시간 포맷이 HH:mm 인지 확인
export const isValidTimeHHmm = (Validator) => {
  Validator.extend('isValidTimeHHmm', {
    getMessage: () => i18n.t('vl.isValidTimeHHmm'),
    validate: (text) => {
      const regEx = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/

      if (!regEx.test(text)) {
        return false
      }
      return true
    }
  })
}

// 시간 포맷이 HH:mm:ss 인지 확인
export const isValidTimeHHmmss = (Validator) => {
  Validator.extend('isValidTimeHHmmss', {
    getMessage: () => i18n.t('vl.isValidTimeHHmmss'),
    validate: (text) => {
      const regEx = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/

      if (!regEx.test(text)) {
        return false
      }
      return true
    }
  })
}

/**
 * 날짜 포맷 확인 (YYYY-MM-DD)
 *
 * @param Validator
 */
export const isValidDate = (Validator) => {
  Validator.extend('isValidDate', {
    getMessage: () => i18n.t('vl.isValidDate'),
    validate: (value) => {
      const regEx = /^(19|20)\d{2}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[0-1])$/

      if (!regEx.test(value)) {
        return false
      }
      return true
    }
  })
}

/**
 * 날짜 비교
 *
 * @param Validator
 */
export const isCompareValidDate = (Validator) => {
  Validator.extend('isCompareValidDate', {
    getMessage: () => i18n.t('vl.isCompareValidDate'),
    validate: (value, [min, max]) => {
      if (max !== 'undefined' && max) {
        if (compareIsAfter(formatDate(value, 'YYYY-MM-DD'), formatDate(max, 'YYYY-MM-DD'))) {
          return false
        }
      }

      if (min !== 'undefined' && min) {
        if (compareIsAfter(formatDate(min, 'YYYY-MM-DD'), formatDate(value, 'YYYY-MM-DD'))) {
          return false
        }
      }

      return true
    }
  })
}

/**
 * 로그 핕터 숫자 유효성 검사
 *  - 숫자, 범위(-), >, <, >=, <=
 *  - 음수 허용
**/
export const isValidComplexNumber = (Validator) => {
  Validator.extend('isValidComplexNumber', {
    getMessage: () => i18n.t('vl.isValidComplexNumber'),
    validate: (pattern) => {
      // 숫자 유효성 범위
      const maxNum = bigInt('18446744073709551615')
      const minNum = bigInt('-9223372036854775808')

      // 숫자가 유효성 범위에 해당하는지 확인
      function checkNumber (val) {
        const num = bigInt(val)
        if (isNaN(num)) return false
        if (num.greater(maxNum)) return false
        if (num.lesser(minNum)) return false
        return true
      }

      // 패턴 체크 시작
      const onlyNumRegex = /^(-?[1-9]|-?[1-9]([0-9]+)|0)$/ // 단일 숫자, 음수 허용
      const conditionRegex = /^(<|>|>=|<=)(-?[1-9]|-?[1-9][0-9]+|0)$/ // 부등호 (>0, <0, >=, <=0), 음수 허용
      const rangeRegex = /^(\-?[1-9]+|\-?[1-9][0-9]+|0)\-(\-?[1-9]+|\-?[1-9][0-9]+|0)$/ // 범위 (숫자-숫자), 음수 허용
      if (onlyNumRegex.test(pattern) || conditionRegex.test(pattern)) {
        const num = pattern.replace(/[><=]/g, '')
        if (!checkNumber(num)) return false
      } else if (rangeRegex.test(pattern)) { // 범위 처리
        const firstStr = pattern.replace(/(\-[0-9]+|\-\-[0-9]+)$/, '')
        const secondStr = pattern.replace(`${firstStr}-`, '')
        const firstNumber = bigInt(firstStr)
        const secondNumber = bigInt(secondStr)
        if (!checkNumber(firstNumber) || !checkNumber(secondNumber)) {
          return false
        }
        if (firstNumber.greaterOrEquals(secondNumber)) {
          return false
        }
      } else {
        return false
      }
      return true
    }
  })
}

/**
 * 로그 핕터 숫자 유효성 검사, 음수 불가
 *  - 정수, 범위(-), >, <, >=, <=
 *  - 음수 불가
**/
export const isValidComplexAbsNumber = (Validator) => {
  Validator.extend('isValidComplexAbsNumber', {
    getMessage: () => i18n.t('vl.isValidComplexAbsNumber'),
    validate: (pattern) => {
      // 숫자 유효성 범위
      const maxNum = bigInt('18446744073709551615')
      const minNum = bigInt('-9223372036854775808')

      // 숫자가 유효성 범위에 해당하는지 확인
      function checkNumber (val) {
        const num = bigInt(val)
        if (isNaN(num)) return false
        if (num.greater(maxNum)) return false
        if (num.lesser(minNum)) return false
        return true
      }

      // 패턴 체크 시작, 음수 불가
      const onlyNumRegex = /^([1-9]|[1-9]([0-9]+)|0)$/ // 단일 숫자, 음수 불가
      const conditionRegex = /^(<|>|>=|<=)([1-9]|[1-9][0-9]+|0)$/ // 부등호 (>0, <0, >=, <=0), 음수 불가
      const rangeRegex = /^([1-9]+|[1-9][0-9]+|0)\-([1-9]+|[1-9][0-9]+|0)$/ // 범위 (숫자-숫자), 음수 불가
      if (onlyNumRegex.test(pattern) || conditionRegex.test(pattern)) {
        const num = pattern.replace(/[><=]/g, '')
        if (!checkNumber(num)) return false
      } else if (rangeRegex.test(pattern)) { // 범위 처리
        const firstStr = pattern.replace(/(\-[0-9]+|\-\-[0-9]+)$/, '')
        const secondStr = pattern.replace(`${firstStr}-`, '')
        const firstNumber = bigInt(firstStr)
        const secondNumber = bigInt(secondStr)
        if (!checkNumber(firstNumber) || !checkNumber(secondNumber)) {
          return false
        }
        if (firstNumber.greaterOrEquals(secondNumber)) {
          return false
        }
      } else {
        return false
      }
      return true
    }
  })
}

// 20자 이하 한글, 영문, 숫자, -, _만 가능
export const isValidKor20 = (Validator) => {
  Validator.extend('isValidKor20', {
    getMessage: () => i18n.t('vl.isValidKor20'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 한글, 영문, 숫자, -, _만 가능
      const regExp = /[^0-9a-zA-Z-_ㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(text)) {
        return false
      }

      // 20자 이하
      const len = text.length
      if (len > 20) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

export const isValidComplexAbsPort = (Validator) => {
  Validator.extend('isValidComplexAbsPort', {
    getMessage: () => i18n.t('vl.isValidComplexAbsPort'),
    validate: (pattern) => {
      // 입력 체크 정규식
      const checkInequality = /^(<|>|<=|>=)?([0-9][0-9]*-|0)?(([1-9][0-9]*)|0)$/

      // 기본 입력 포맷 체크
      if (!checkInequality.test(pattern)) {
        return false
      }

      // 범위 체크 시작
      const splitPattern = pattern.split('-')

      // 잘린 문자열이 2 ~ 4라면 범위
      // 2인 경우 모두 양수
      // 3인 경우 앞에가 음수. 뒤가 음수 범위가 될 수 없음.
      // 4인 경우 모두 음수.
      const splitPatternCount = splitPattern.length || 0

      // 이상한 문자열 차단
      if (splitPatternCount > 4) {
        return false
      }

      // 패턴 체크 시작
      if (splitPatternCount >= 2 && splitPatternCount <= 4) {
        // 분리된 문자열이 2개이고 첫번째 값이 빈 문자열이면 마이너스 정수
        if (splitPatternCount === 2 && splitPattern[0] === '') {
          return true
        }

        // 정수 변환
        const firstNumber = Number(`${splitPatternCount === 3 || splitPatternCount === 4 ? '-' : ''}${splitPattern[splitPatternCount === 2 ? 0 : 1]}`)
        const secondNumber = Number(`${splitPatternCount === 4 ? '-' : ''}${splitPattern[splitPatternCount === 2 ? 1 : splitPatternCount === 3 ? 2 : 3]}`)

        // 변환된 숫자가 isNaN이면 False
        if (isNaN(firstNumber) || isNaN(secondNumber)) {
          return false
        }

        // 첫번째 숫자가 두번째 숫자보다 크거나 같으면 에러
        if (firstNumber >= secondNumber) {
          return false
        }

        // 변환된 숫자 중 65535를 넘어서는 경우
        if (firstNumber > 65535 || secondNumber > 65535) {
          return false
        }
      } else {
        const checkInequality2 = /^(<=|>=|<|>)/

        if (checkInequality2.test(pattern[0])) {
          pattern = pattern.replace(checkInequality2, '')
        }

        const convertPort = Number(pattern)

        if (isNaN(convertPort) || convertPort > 65535) {
          return false
        }
      }

      return true
    }
  })
}

/**
 * isIpsIpv4ValidPrefix
 * IPS/DDoS 예외 호스트에서 IPv4 Prefix 유효성 검증. 8~31
 */
export const isIpsIpv4ValidPrefix = (Validator) => {
  Validator.extend('isIpsIpv4ValidPrefix', {
    getMessage: () => i18n.t('vl.isIpsIpv4ValidPrefix'),
    validate: (prefix) => {
      // 문자열 형식의 프리픽스에서 숫자 프리픽스 검출
      if (/\//.test(prefix)) {
        const networkArr = prefix.split('/')
        prefix = networkArr[1]
        if (!Number.isInteger(+(prefix))) {
          return false
        }
      }

      const ipv4Regex = /^(([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])\.){3}([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])(\/(?:3[012]|[012]?[0-9])|)$/
      if (ipv4Regex.test(prefix)) return true

      const numPrefix = Number(prefix)

      if (numPrefix >= 24 && numPrefix <= 32) {
        return true
      }

      return false
    }
  })
}

/**
 * isIpsIpv6ValidPrefix
 * IPS/DDoS 예외 호스트에서 IPv6 Prefix 유효성 검증. 16~127
 * Prefix: 16~127 (Network 객체), 128 (Host 객체)
 */
export const isIpsIpv6ValidPrefix = (Validator) => {
  Validator.extend('isIpsIpv6ValidPrefix', {
    getMessage: () => i18n.t('vl.isIpsIpv6ValidPrefix'),
    validate: (prefix) => {
      // 문자열 형식의 프리픽스에서 숫자 프리픽스 검출
      if (/\//.test(prefix)) {
        const networkArr = prefix.split('/')
        prefix = networkArr[1]
        if (!Number.isInteger(+(prefix))) {
          return false
        }
      }

      const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/
      if (ipv6Regex.test(prefix)) return true

      const numPrefix = Number(prefix)

      if (numPrefix >= 64 && numPrefix <= 128) {
        return true
      }

      return false
    }
  })
}

/**
 * 날짜 시간 포맷 확인 (YYYY-MM-DD HH:mm)
 *
 * @param {object} Validator
 */
export const isValidDateTime = (Validator) => {
  Validator.extend('isValidDateTime', {
    getMessage: () => i18n.t('vl.isValidDateTime'),
    validate: (value) => {
      const regEx = /^(19|20)\d{2}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[0-1]) ([01][0-9]|2[0-3]):([0-5][0-9])$/

      if (!regEx.test(value)) {
        return false
      }
      return true
    }
  })
}

/**
 * 날짜 시간 포맷 확인 (YYYY-MM-DD HH:mm:ss)
 *
 * @param {object} Validator
 */
export const isValidDateTimeHHmmss = (Validator) => {
  Validator.extend('isValidDateTimeHHmmss', {
    getMessage: () => i18n.t('vl.isValidDateTimeHHmmss'),
    validate: (value) => {
      const regExTime = /^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
      let dateTime = value.split(' ')
      let date = dateTime[0].split('-')
      let time = dateTime[1]

      if (!regExTime.test(time)) {
        return false
      }

      let dayOfMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

      let year = parseInt(date[0], 10)
      let month = parseInt(date[1], 10)
      let day = parseInt(date[2], 10)

      if (year < 1900 || year > 2099 || month === 0 || month > 12) {
        return false
      }

      // Leap Year
      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        dayOfMonth[1] = 29
      }

      return day > 0 && day <= dayOfMonth[month - 1]
    }
  })
}

/**
 * 날짜 비교 (YYYY-MM-DD HH:mm)
 *
 * @param {object} Validator
 */
export const isCompareValidDateTime = (Validator) => {
  Validator.extend('isCompareValidDateTime', {
    getMessage: () => i18n.t('vl.isCompareValidDateTime'),
    validate: (value, [min, max]) => {
      if (max !== 'undefined' && max) {
        if (compareIsAfter(formatDate(value, 'YYYY-MM-DD HH:mm'), formatDate(max, 'YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm')) {
          return false
        }
      }

      if (min !== 'undefined' && min) {
        if (compareIsAfter(formatDate(min, 'YYYY-MM-DD HH:mm'), formatDate(value, 'YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm')) {
          return false
        }
      }

      return true
    }
  })
}

/**
 * 날짜 비교 (YYYY-MM-DD HH:mm:ss)
 *
 * @param {object} Validator
 */
export const isCompareValidDateTimeHHmmss = (Validator) => {
  Validator.extend('isCompareValidDateTimeHHmmss', {
    getMessage: () => i18n.t('vl.isCompareValidDateTime'),
    validate: (value, [min, max]) => {
      if (max !== 'undefined' && max) {
        if (compareIsAfter(formatDate(value, 'YYYY-MM-DD HH:mm:ss'), formatDate(max, 'YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss')) {
          return false
        }
      }

      if (min !== 'undefined' && min) {
        if (compareIsAfter(formatDate(min, 'YYYY-MM-DD HH:mm:ss'), formatDate(value, 'YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss')) {
          return false
        }
      }

      return true
    }
  })
}

// 큰따옴표(") 특수문자 입력이 불가능
export const isValidVpnDoubleQuotes = (Validator) => {
  Validator.extend('isValidVpnDoubleQuotes', {
    getMessage: () => i18n.t('vl.isValidVpnDoubleQuotes'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 큰따옴표 포함 체크
      if (text.indexOf('"') >= 0) {
        return false
      }

      return true
    }
  })
}

/**
 * 단일 정수
 * 단일값 - 단일값으로 하이픈(-)이 있는 범위 지정
 * min: 최솟값
 * max: 최댓값
 *
 * @param Validator
 */
export const isValidNumberRange = (Validator) => {
  Validator.extend('isValidNumberRange', {
    getMessage: () => i18n.t('vl.isValidNumberRange'),
    validate: (value, [min, max]) => {
      const portRegex = /^([0-9][0-9]*-|0)?(([0-9][0-9]*)|0)$/

      if (!portRegex.test(value)) {
        return false
      }

      if (value.indexOf('-') !== -1) {
        const portArr = value.split('-')
        const num1 = Number(portArr[0])
        const num2 = Number(portArr[1])

        if (num1 === num2) {
          return false
        }

        if (num1 < 0 || num2 < 0 || num1 > num2) {
          return false
        }

        if (num1 < min || num1 > max || num2 < min || num2 > max) {
          return false
        }
      } else {
        const num = Number(value)

        if (num < 0) {
          return false
        }

        if (num < min || num > max) {
          return false
        }
      }

      return true
    }
  })
}

// 32자 이하 영문, 숫자, _만 가능
export const isValidRouteMapName = (Validator) => {
  Validator.extend('isValidRouteMapName', {
    getMessage: () => i18n.t('vl.isValidRouteMapName'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // 영문, 숫자, _만 가능
      const regExp = /[^0-9a-zA-Z-_]/gi
      if (regExp.test(text)) {
        return false
      }

      // 32자 이하
      const len = text.length
      if (len > 32) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

// 특수문자 #, %, &, ', :, <, ?, `, ^, \, +, |, {, }, ", > 는 입력 불가
export const isValidUrlSpecialChar = (Validator) => {
  Validator.extend('isValidUrlSpecialChar', {
    getMessage: () => i18n.t('vl.isValidUrlSpecialChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      // #, %, &, ', :, <, ?, `, ^, \, +, |, {, }, ", > 는 입력 불가
      const regExp = /[#%&':<?`^\\+|{}">]/gi
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

/**
 * 최대 255자의 영문, 숫자, 특수문자 (! * ' ( ) ; : @ & = + $ , / ? # [ ] 제외)만 입력할 수 있습니다.
 *  - 한글 불가, 빈칸 불가, 255자 이상 불가
 *  - ! * ' ( ) ; : @ & = + $ , / ? # [ ]의 특수문자 불가
 **/
export const isValidOtpParamsName = (Validator) => {
  Validator.extend('isValidOtpParamsName', {
    getMessage: () => i18n.t('vl.isValidOtpParamsName'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 255자 이하
      const len = text.length
      if (len > 255) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(text)) {
        return false
      }

      // 특수 문자 제외 (! * ' ( ) ; : @ & = + $ , / ? # [ ])
      const regExp = /[!*'\(\);:@&=+$,\/?#\[\] ]/g
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

/**
 * 32자 이하 한글, 영문, 숫자, 특수기호(# 제외)만 가능
 **/
export const isValidTagName = (Validator) => {
  Validator.extend('isValidTagName', {
    getMessage: () => i18n.t('vl.isValidTagName'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 32자 이하
      const len = text.length
      if (len > 32) {
        return false
      }

      // 특수 문자 제외 (#)
      const regExp = /[#]/g
      if (regExp.test(text)) {
        return false
      }

      // space 포함 체크
      if (text.indexOf(' ') >= 0) {
        return false
      }

      return true
    }
  })
}

/**
 * 단말 보안 인증 암호화 키
 **/
export const isValidProAlgrKey = (Validator) => {
  Validator.extend('isValidProAlgrKey', {
    getMessage: () => i18n.t('vl.isValidProAlgrKey'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 32자 이상
      const len = text.length
      if (len < 32) {
        return false
      }

      return true
    }
  })
}

/* ======================================================================= */
// TAMS
// 공백과 최소 4자리 체크
export const isValidSpaceNameMin4 = (Validator) => {
  Validator.extend('isValidSpaceNameMin4', {
    getMessage: () => i18n.t('vl.isValidSpaceNameMin4'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }
      if (text.length < 4) {
        return false
      }
      return true
    }
  })
}

// 공백은 정상이지만 입력받았을 경우 최소 4자리 체크
export const isValidSpaceNameMin4andNotNull = (Validator) => {
  Validator.extend('isValidSpaceNameMin4andNotNull', {
    getMessage: () => i18n.t('vl.isValidSpaceNameMin4andNotNull'),
    validate: text => {
      if (text === undefined || text === null) {
        return true
      }
      if (text.length < 4) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidNameLenth
 * 입력된 이름 길이 유효성 검증. min ~ max 입력가능.
 */
export const isValidNameLenth = (Validator) => {
  Validator.extend('isValidNameLenth', {
    getMessage: (text, [min, max]) => {
      return `${i18n.t('vl.isValidNameLenth')} ${i18n.t('cmn.textRange', {min, max})}`
    },
    validate: (text, [min, max]) => {
      // max자 이상 min자 이하
      const len = _.get(text, ['length'], 0)

      if (len >= min && len <= max) {
        return true
      }

      return false
    }
  })
}

/**
 * isValidIPall
 * IPv4, IPv4 범위, IPv4 대역, IPv6, IPv6 범위, IPv6 대역 입력
 */
export const isValidIPall = (Validator) => {
  Validator.extend('isValidIPall', {
    getMessage: () => i18n.t('vl.isValidIPall'),
    validate: (text) => {
      if (!text) {
        return false
      }
      // 영문 a~F, 숫자, 특수문자(.,:,-,/) 만 입력 가능
      const regExp = /[^0-9a-fA-F\.\:\-\/]/gi
      if (regExp.test(text)) {
        return false
      }

      // 공백은 입력 불가
      const emptyExp = /\s/g
      if (emptyExp.test(text)) {
        return false
      }

      // - 기호는 한번만 사용가능
      const dashCount = (text.match(/\-/g) || []).length
      if (dashCount > 1) {
        return false
      }

      // / 기호는 한번만 사용가능
      const slashCount = (text.match(/\//g) || []).length
      if (slashCount > 1) {
        return false
      }

      // - 기호와 / 기호는 동시 사용 불가
      if (dashCount === 1 && slashCount === 1) {
        return false
      }
      const ipv4Regex = /^(([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])\.){3}([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])(\/(?:3[012]|[012]?[0-9])|)$/
      const ipv6Regex = /^^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/

      if (text.includes('/')) { // IP 대역 입력
        const ipArray = text.split('/')
        const ip = ipArray[0]
        const mask = ipArray[1]
        const regExpNum = /^[0-9]*$/
        if (!regExpNum.test(mask)) { // netMask 가 아닌 값이 들어오면 return false
          return false
        }

        if (ipv4Regex.test(ip)) { // ipv4 형식일 때, net mask 도 조건에 맞으면 return true
          if (mask > 0 && mask < 33) {
            return true
          }
        }

        if (ipv6Regex.test(ip)) { // ipv6 형식일 때, net mask 도 조건에 맞으면 return true
          if (mask > 0 && mask < 129) {
            return true
          }
        }
      } else if (text.includes('-')) { // IP 범위 입력
        const ipArray = text.split('-')
        const startIp = ipArray[0]
        const endIp = ipArray[1]
        if (ipv4Regex.test(startIp) && ipv4Regex.test(endIp)) { // 시작과 끝 ip address 가 Ipv4 형식이 맞으면 return true
          return true
        } else if (ipv6Regex.test(startIp) && ipv6Regex.test(endIp)) { // 시작과 끝 ip address 가 Ipv6 형식이 맞으면 return true
          return true
        }
      } else {
        if (ipv4Regex.test(text)) { // Ipv4 형식이 맞으면 return true
          return true
        } else if (ipv6Regex.test(text)) { // Ipv6 형식이 맞으면 return true
          return true
        }
      }
      // 이상 없으면 return true
      return false
    }
  })
}

export const isValidSpecialChar = (Validator) => {
  Validator.extend('isValidSpecialChar', {
    getMessage: () => i18n.t('vl.isValidSpecialChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      const spCharList = ['\'', '"', '\\', ';', '--', '+', '#', '`', '^', '|']

      for (const spChar of spCharList) {
        if (text.indexOf(spChar) !== -1) {
          return false
        }
      }

      return true
    }
  })
}

export const isValidTamsSpecialChar = (Validator) => {
  Validator.extend('isValidTamsSpecialChar', {
    getMessage: () => i18n.t('vl.isValidTamsSpecialChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      const spCharList = ['\'', '"', ';', '\\', '--', '+', '|']

      for (const spChar of spCharList) {
        if (text.indexOf(spChar) !== -1) {
          return false
        }
      }

      return true
    }
  })
}

export const isValidTamsSpecialChar2 = (Validator) => {
  Validator.extend('isValidTamsSpecialChar2', {
    getMessage: () => i18n.t('vl.isValidTamsSpecialChar2'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      const spCharList = ['\'', '"', ';', '`', '^', '--', '#', '>', '<', '&', '|', '$', '{', '}']
      for (const spChar of spCharList) {
        if (text.indexOf(spChar) !== -1) {
          return false
        }
      }

      return true
    }
  })
}

export const isValidDirSpecialChar = (Validator) => {
  Validator.extend('isValidDirSpecialChar', {
    getMessage: () => i18n.t('vl.isValidDirSpecialChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      const spCharList = ['..', '|', '>', '<', '*', ';', '&', '@', '\\', '"', '$', '(', ')', ' ', '`', '‘']

      for (const spChar of spCharList) {
        if (text.indexOf(spChar) !== -1) {
          return false
        }
      }

      return true
    }
  })
}

export const isValidSnortSpecialChar = (Validator) => {
  Validator.extend('isValidSnortSpecialChar', {
    getMessage: () => i18n.t('vl.isValidSnortSpecialChar'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      const spCharList = ['^', ';']

      for (const spChar of spCharList) {
        if (text.indexOf(spChar) !== -1) {
          return false
        }
      }

      return true
    }
  })
}

/**
 * isValidIPv4
 * IPv4 주소(단일,마스크,범위) 유효성 검사 수행.
 */
export const isValidIPv4MaskRange = (Validator) => {
  Validator.extend('isValidIPv4MaskRange', {
    getMessage: () => i18n.t('vl.isValidIPv4MaskRange'),
    validate: (ipList) => {
      if (ipList.length > 0) {
        ipList = ipList.replace(' ', '')

        const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
        const ipv4MaskRegex = /^(([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])\.){3}([01]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])(\/(?:3[012]|[012]?[0-9])|)$/

        if (ipList.indexOf('-') >= 0) { // Range
          const ipv4List = ipList.split('-')

          if (ipv4List.length !== 2) {
            return false
          } else {
            if (!ipv4Regex.test(ipv4List[0])) {
              return false
            } else if (!ipv4Regex.test(ipv4List[1])) {
              return false
            }
          }
        } else if (ipList.indexOf('/') >= 0) { // NetMask
          if (!ipv4MaskRegex.test(ipList)) {
            return false
          }
        } else { // 순수 IP
          if (!ipv4Regex.test(ipList)) {
            return false
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

/**
 * 영문, 숫자, 한글
 */
export const isValidEngNumKor = (Validator) => {
  Validator.extend('isValidEngNumKor', {
    getMessage: () => i18n.t('vl.isValidEngNumKor'),
    validate: (id) => {
      // 영문, 숫자, 한글만 가능
      const regExp = /[^\s0-9a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣]/gi
      if (regExp.test(id)) {
        return false
      }
      const emptyExp = /\s/g
      if (emptyExp.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidLoginIdA2
 * 첫글자는 영문으로 시작하고, 영문/숫자만 가능함. 4~32자리, 4개의 특수문자 허용 (.-_@)
 * Email 도 가능
 */
export const isValidLoginIdA2 = (Validator) => {
  Validator.extend('isValidLoginIdA2', {
    getMessage: () => i18n.t('vl.isValidLoginIdA2'),
    validate: (id) => {
      const idReg = /^[a-zA-Z]+[a-zA-Z0-9|\-._@]{3,31}$/g
      if (!idReg.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * isValidBondName
 * 첫글자는 영문으로 시작하고, 영문/숫자만 가능함. 2~16자리
 * 반드시 영문/숫자를 혼용해야 함.
 */
export const isValidBondName = (Validator) => {
  Validator.extend('isValidBondName', {
    getMessage: () => i18n.t('vl.isValidBondName'),
    validate: (id) => {
      const idReg = /^[a-zA-Z]+[a-zA-Z0-9]{1,15}$/g
      if (!idReg.test(id)) {
        return false
      }
      const regExpNum = /[0-9]/
      if (!regExpNum.test(id)) {
        return false
      }
      return true
    }
  })
}

/**
 * isEventPort
 * 이벤트정책 포트 사양
 */
export const isEventPort = (Validator) => {
  Validator.extend('isEventPort', {
    getMessage: () => i18n.t('vl.isValidPort'),
    validate: (port) => {
      let prots = port.split('-')
      let firstPort = Number(prots[0])
      if (prots.length === 1) {
        if (firstPort > 65535) {
          return false
        }
      } else {
        if (prots.length > 2) {
          return false
        }
        let lastPort = Number(prots[1])
        if (lastPort > 65535 || firstPort >= lastPort) {
          return false
        }
      }
      return true
    }
  })
}

/**
 * isValidUserDefineRangePort
 * 사용자정의 시그니처에서 사용
 * Port의 범위에 대한 중복 체크
 */
export const isValidUserDefineRangePort = (Validator) => {
  Validator.extend('isValidUserDefineRangePort', {
    getMessage: () => i18n.t('vl.isValidUserDefineRangePort'),
    validate: (text) => {
      const portRegex = /^(?:(?:\d{1,5}\:|\:\d{1,5}|\d{1,5}\:\d{1,5}|\d{1,5})(\,(?:\d{1,5}\:|\:\d{1,5}|\d{1,5}\:\d{1,5}|\d{1,5})){0,9})$/
      if (!portRegex.test(text) || text === '') {
        return true
      }
      const ports = text.split(',')
      if (ports.length < 1) {
        return true
      }

      let isValid = true

      const checkPortType = (port) => { // single, range
        if (/^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/.test(port)) { // singleType
          return 'single'
        }
        if (/^(?:\d{1,5}\:|\:\d{1,5}|\d{1,5}\:\d{1,5})$/.test(port)) { // rangeType
          return 'range'
        }
      }

      const comparePorts = () => {
        const portItem = ports.pop()
        const portItemType = checkPortType(portItem)
        for (let i = 0, l = ports.length; i < l; i++) {
          const compareItem = ports[i]
          const compareItemType = checkPortType(compareItem)
          if (portItemType === 'single' && compareItemType === 'single') {
            compareSingleToSingle(portItem, compareItem)
          } else if (portItemType === 'single' && compareItemType === 'range') {
            compareSingleToRange(portItem, compareItem)
          } else if (portItemType === 'range' && compareItemType === 'single') {
            compareSingleToRange(compareItem, portItem)
          } else if (portItemType === 'range' && compareItemType === 'range') {
            compareRangeToRange(portItem, compareItem)
          }
        }
      }

      const compareSingleToSingle = (a, b) => {
        if (a === b) {
          isValid = false
        }
      }

      const compareSingleToRange = (a, b) => {
        if (/^\:\d{1,5}$/.test(b)) {
          const bMax = Number(b.split(':')[1])
          if (bMax >= a) {
            isValid = false
          }
        } else if (/^\d{1,5}\:$/.test(b)) {
          const bMin = Number(b.split(':')[0])
          if (bMin <= a) {
            isValid = false
          }
        } else {
          const bMin = Number(b.split(':')[0])
          const bMax = Number(b.split(':')[1])
          if (bMin <= a && bMax >= a) {
            isValid = false
          }
        }
      }

      const compareRangeToRange = (a, b) => {
        const aMin = Number(a.split(':')[0])
        const aMax = Number(a.split(':')[1])
        const bMin = Number(b.split(':')[0])
        const bMax = Number(b.split(':')[1])
        const lessThenRegex = /^\:\d{1,5}$/ // 이하
        const greaterThenRegex = /^\d{1,5}\:$/ // 이상
        const rangeRegex = /^\d{1,5}\:\d{1,5}$/ // 범위

        if (lessThenRegex.test(a) && lessThenRegex.test(b)) { // 이하 : 이하
          if (aMax >= bMax || bMax >= aMax) isValid = false
        } else if (lessThenRegex.test(a) && greaterThenRegex.test(b)) { // 이하 : 이상
          if (aMax >= bMin || bMin <= aMax) isValid = false
        } else if (lessThenRegex.test(a) && rangeRegex.test(b)) { // 이하 : 범위
          if (aMax >= bMin || aMax >= bMax) isValid = false
          if (bMin <= aMax && bMax >= aMax) isValid = false
        } else if (greaterThenRegex.test(a) && lessThenRegex.test(b)) { // 이상 : 이하
          if (aMin <= bMax || bMax >= aMin) isValid = false
        } else if (greaterThenRegex.test(a) && greaterThenRegex.test(b)) { // 이상 : 이상
          if (aMin <= bMin || bMin <= aMin) isValid = false
        } else if (greaterThenRegex.test(a) && rangeRegex.test(b)) { // 이상 : 범위
          if (aMin <= bMin || aMin <= bMax) isValid = false
          if (bMin <= aMin && bMax >= aMin) isValid = false
        } else if (rangeRegex.test(a) && lessThenRegex.test(b)) { // 범위 : 이하
          if (aMin <= bMax && aMax >= bMax) isValid = false
          if (bMax >= aMin || bMax >= aMax) isValid = false
        } else if (rangeRegex.test(a) && greaterThenRegex.test(b)) { // 범위 : 이상, aMin, aMax, bMin
          if (aMin <= bMin && aMax <= bMin) isValid = false
          if (bMin <= aMin || bMin <= aMax) isValid = false
        } else { // 범위 : 범위
          if ((aMin <= bMin && aMax >= bMin) || (aMin <= bMax && aMax >= bMax)) isValid = false
          if ((bMin <= aMin && bMax >= aMin) || (bMin <= aMax && bMax >= aMax)) isValid = false
        }
      }

      while (ports.length) {
        comparePorts()
        if (isValid === false) {
          return isValid // false
        }
      }
      return isValid // true
    }
  })
}

/**
 * isValidVlan
 * 쉼표로 구분된 여러개의 VLAN ID 검증. (TAMS)
 */
export const isValidVlan = (Validator) => {
  Validator.extend('isValidVlan', {
    getMessage: () => i18n.t('vl.isValidVlan'),
    validate: (vlanList) => {
      if (vlanList.length > 0) {
        vlanList = vlanList.replace(' ', '')
        // 쉼표로 구분된 IP 분리
        const vlanArr = vlanList.split(',')
        const minVlan = 1, maxVlan = 4094
        // 반복문으로 각 IP 체크
        for (let i = 0, max = vlanArr.length; i < max; i++) {
          // 유효성 검사를 통과하지 못하면 return false
          const strVal = vlanArr[i]
          if (strVal.indexOf('-') > -1) { // '-' 는 범위
            const strArr = strVal.split('-')
            if (strArr.length > 2 || strArr[0] === '' || strArr[1] === '') { // 잘못된 형식
              return false
            } else { // 범위 검사
              const num1 = Number(strArr[0])
              const num2 = Number(strArr[1])
              let numNan = isNaN(num1) || isNaN(num2)
              let numMax = num1 > maxVlan || num2 > maxVlan
              let numMin = num1 < minVlan || num2 < minVlan
              if (numNan || numMax || numMin || num1 > num2) {
                return false
              }
            }
          } else {
            const num = Number(strVal)
            if (strVal === '' || isNaN(num) || num > maxVlan || num < minVlan) {
              return false
            }
          }
        }
      }

      // 이상 없으면 return true
      return true
    }
  })
}

// TAMS
export const isValidNaturalNumbers = (Validator) => {
  Validator.extend('isValidNaturalNumbers', {
    getMessage: () => i18n.t('vl.isValidNaturalNumbers'),
    validate: (text) => {
      const regex = /^[0-9]+$/
      if (!regex.test(text)) {
        return false
      }
      return true
    }
  })
}

// TAMS
// WIPS 장비 관리 팝업 Client Secret Confirm
export const isValidCsConfirm = (Validator) => {
  Validator.extend('isValidCsConfirm', {
    getMessage: () => i18n.t('vl.isValidCsConfirm'),
    validate: (csConfirm, [originCs]) => {
      if (!_.isEqual(csConfirm, originCs)) {
        return false
      }

      return true
    }
  })
}

// 한글 불가, 영문 소문자 + 숫자 만 가능
export const isValidLowerCaseAndNumeric = (Validator) => {
  Validator.extend('isValidLowerCaseAndNumeric', {
    getMessage: () => i18n.t('vl.isValidLowerCaseAndNumeric'),
    validate: text => {
      if (text === undefined || text === null) {
        return false
      }

      // 영문 소문자 + 숫자 만 가능
      const regExp = /[^0-9a-z]/
      if (regExp.test(text)) {
        return false
      }

      return true
    }
  })
}

/**
 * 키보드상의 연속성을 갖는 영문자, 숫자 문자열 금지(예: qwe, asd, abc, 123) / 역순 금지(예: cba, 321)
 * 4자리 이상 금지
**/
export const isValidNotChainKeyboard = (Validator) => {
  Validator.extend('isValidNotChainKeyboard', {
    getMessage: () => i18n.t('vl.isValidNotChainKeyboard'),
    validate: text => {
      // 숫자, 소문자, 대문자 키보드 배열 및 역순
      const word = ['qwertyuiop', 'asdfghjkl', 'zxcvbnm']
      const wordAll = ['1234567890', ...word]
      const reverseWord = [...wordAll.map(w => [...w].reverse().join(''))]
      const keyboard = [...wordAll, ...reverseWord]

      for (let i = 0; i < text.length - 3; i++) {
        const sliceValue = text.substring(i, i + 4).toLowerCase()
        // 모든 조건을 한번씩 순회
        if (keyboard.some(code => code.includes(sliceValue))) return false
      }
      return true
    }
  })
}

/**
 * isValidComplexPwd
 * CC 전용 비밀번호 - 모든 연동용 비밀번호 (관리자 비밀번호 제외)
 * 1. 한글 포함 체크
 * 2. 9자 이상 128자 이하
 * 3. space 포함 체크
 * 4. 영문 대문자,영문 소문자,숫자,특수문자 조합 ( 반드시 4가지 종류가 다 포함되어야 함)
 * 5. 모든 특수문자 가능
 */
export const isValidComplexPwd = (Validator) => {
  Validator.extend('isValidComplexPwd', {
    getMessage: () => i18n.t('vl.isValidComplexPwd'),
    validate: pwd => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      if (/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(pwd)) return false

      // 9자 이상 128자 이하
      const len = pwd.length
      if (len < 9 || len > 128) return false

      // space 포함 체크
      if (pwd.indexOf(' ') >= 0) return false

      // 영문 대문자, 영문 소문자, 숫자, 특수문자 조합 ( 반드시 4가지 종류가 다 포함되어야 함)
      // 모든 특수문자 가능
      const regExp1 = /[a-z]/
      const regExp2 = /[A-Z]/
      const regExp3 = /[0-9]/
      const regExp4 = /[~|!|@|#|$|%|&|*|(|)|_|+|\-|=|\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\]|\\{|\\}|\\`|\\.|\\:|\\;|\\"|\\'|\\|]/

      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd) || !regExp4.test(pwd)) {
        return false
      }

      return true
    }
  })
}

/**
 * isValidMailComplexPwd
 * CC 전용 비밀번호 - 모든 연동용 비밀번호 (관리자 비밀번호 제외)
 * 1. 한글 포함 체크
 * 2. 9자 이상 32자 이하
 * 3. space 포함 체크
 * 4. 영문 대문자,영문 소문자,숫자,특수문자 조합 ( 반드시 4가지 종류가 다 포함되어야 함)
 * 5. 모든 특수문자 가능
 */
export const isValidMailComplexPwd = (Validator) => {
  Validator.extend('isValidMailComplexPwd', {
    getMessage: () => i18n.t('vl.isValidComplexPwd'),
    validate: (pwd) => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      if (/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(pwd)) return false

      // 9자 이상 128자 이하
      const len = pwd.length
      if (len < 9 || len > 32) return false

      // space 포함 체크
      if (pwd.indexOf(' ') >= 0) return false

      // 영문 대문자, 영문 소문자, 숫자, 특수문자 조합 ( 반드시 4가지 종류가 다 포함되어야 함)
      // 모든 특수문자 가능
      const regExp1 = /[a-z]/
      const regExp2 = /[A-Z]/
      const regExp3 = /[0-9]/
      const regExp4 = /[~|!|@|#|$|%|&|*|(|)|_|+|\-|=|\\,|\\/|\\<|\\>|\\?|\\\\|\\^|\\[|\]|\\{|\\}|\\`|\\.|\\:|\\;|\\"|\\'|\\|]/

      if (!regExp1.test(pwd) || !regExp2.test(pwd) || !regExp3.test(pwd) || !regExp4.test(pwd)) {
        return false
      }

      return true
    }
  })
}
/**
 * isValidComplexPwd2
 * snmp 설정 추가 암호 체크
 * 1. 한글 미포함
 * 2. 9자 이상 32자 이하
 * 3. space 포함 체크
 * 4. 영문 대소문자,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
 * 5. 특수문자는 -.#@=:_ 만 가능
 * 6. 문자나 숫자 3자리 이상 연속/반복 입력 불가
 */
export const isValidComplexPwd2 = (Validator) => {
  Validator.extend('isValidComplexPwd2', {
    getMessage: () => i18n.t('vl.isValidComplexPwd'),
    validate: pwd => {
      if (pwd === undefined || pwd === null) {
        return false
      }

      // 한글 포함 체크
      const regExpKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
      if (regExpKor.test(pwd)) {
        return false
      }

      // 9자 이상 32자 이하
      const len = pwd.length
      if (len < 9 || len > 32) {
        return false
      }

      // 영문 대소문자,숫자,특수문자 조합 ( 반드시 3가지 종류가 다 포함되어야 함)
      // 특수문자는 -.#@=:_ 만 가능
      // 공백(space) 허용
      const regExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[0-9a-zA-Z.\-#@=:_\s]+$/

      if (!regExp.test(pwd)) {
        return false
      }

      // PW 똑같은/연속된 문자나 숫자를 3자리 이상 연속 체크
      const regexNo = /(\w)\1\1/
      if (!regexNo.test(pwd)) {
        if (!stck(pwd, 3)) {
          // 연속된 3자리 문자 사용 불가
          return false
        }
      } else {
        // 3개 이상 동일한 문자 사용 불가
        return false
      }

      return true
    }
  })
}

// PW 똑같은/연속된 문자나 숫자를 3자리 이상 연속 체크
export const isValidCharacter = (Validator) => {
  Validator.extend('isValidCharacter', {
    getMessage: () => i18n.t('vl.isValidComplexPwd'),
    validate: pwd => {
      // PW 똑같은/연속된 문자나 숫자를 3자리 이상 연속 체크
      const regexNo = /(\w)\1\1/
      if (!regexNo.test(pwd)) {
        if (!stck(pwd, 3)) {
          // 연속된 3자리 문자 사용 불가
          return false
        }
      } else {
        // 3개 이상 동일한 문자 사용 불가
        return false
      }

      return true
    }
  })
}

export const isValidSimilarIdPw = (Validator) => {
  Validator.extend('isValidSimilarIdPw', {
    getMessage: () => i18n.t('vl.isValidComplexPwd'),
    validate: (pwd, [loginId]) => {
      pwd = pwd.replace(/,/gi, 'COMMA').replace(/\|/gi, 'PIPE')

      if (loginId.length === 0) {
        return true
      }
      // ID와 3자리 이상 중복 불가
      for (let i = 0; i < loginId.length - 2; i++) {
        const word = loginId.substr(i, 3)
        if (pwd.indexOf(word) >= 0) {
          return false
        }
      }

      // ID 역순의 패스워드 검사
      const reverseId = loginId.split('').reverse().join('')
      if (pwd.indexOf(reverseId) >= 0) {
        return false
      }

      return true
    }
  })
}
